import { helpZhHant } from "./help.zh-Hant";

export const languageChineseTraditional = {
    "formating": {
        "main": "主要提示詞",
        "jailbreak": "越獄提示詞",
        "chats": "過往對話",
        "lorebook": "Lorebook",
        "globalNote": "全域備註",
        "authorNote": "作者備註",
        "lastChat": "最近一次對話",
        "description": "角色描述",
        "personaPrompt": "使用者人設",
        "plain": "一般提示詞",
        "memory": "Supa/HypaMemory",
        "postEverything": "結尾注入提示詞",
    },
    "errors": {
        "toomuchtoken": "錯誤：最低所需 Token 數已超過最大上下文長度",
        "unknownModel": "錯誤：無法識別所選的模型",
        "httpError": "錯誤：請求發生錯誤：",
        "noData": "檔案格式錯誤或資料已損毀",
        "onlyOneChat": "至少需要保留一個對話",
        "onlyOnePreset": "至少需要保留一個預設集",
        "noUserIcon": "請先設定您的個人頭像",
        "emptyText": "文字內容為空",
        "wrongPassword": "密碼錯誤",
        "coldStorageWriteFailed": "冷儲存寫入失敗。您的對話資料已被保留",
        "coldStorageVerifyFailed": "冷儲存驗證失敗。您的對話資料已被保留",
        "vertexAuthError": "缺少 Vertex AI 驗證資訊",
        "networkFetch": "通常是網路連線不穩定，或伺服器暫時無法使用所致",
        "networkFetchWeb":
            "這可能是 CORS 錯誤。由於瀏覽器限制，此問題只會在網頁版發生。請嘗試使用桌面本機版或其他版本的 PocketRisu",
        "networkFetchPlain": "這可能是一般 Fetch 錯誤。請嘗試在設定中停用「強制一般 Fetch」",
        "requestLogRemoved": "此請求記錄已被移除",
        "requestLogRemovedDesc": "重新整理或重新載入用戶端後，請求記錄會被移除",
        "persistFailureTitle": "伺服器儲存失敗 — 變更未寫入磁碟",
        "persistFailureAttemptedSize": "嘗試儲存的大小",
        "storageRequestTooLarge": "儲存請求因資料過大而失敗（HTTP 413）。請檢查伺服器或反向代理（例如 Nginx）的 Request Body 大小上限",
        "backupEncryptedAccount": "此備份是從 RisuAI 網頁版（risuai.xyz）匯出的。其資料庫已加密，只能在 risuai.xyz 上開啟，因此 PocketRisu 無法讀取。請在 RisuAI 中開啟「將資料儲存至帳號」，再使用「設定 > 資料移轉」中的「從 RisuAI 帳號匯入」。詳細步驟請參閱遷移指南。您現有的資料未被取代。",
        "chatGuardTitle": "已觸發對話資料保護 — 已切換至安全儲存模式",
        "chatGuardDesc": "系統已阻擋可疑的儲存模式。您的變更會改用安全的完整寫入方式儲存。若持續發生，請連同瀏覽器主控台記錄一起回報問題",
        "chatGuardPersistTitle": "為保護現有對話資料，已中止儲存",
        "backgroundGenerationFailed": "背景生成失敗（{char}）：{error}",
        "modelJobBusy": "此對話仍在伺服器上生成中。完成後會自動補上回應，請稍候",
        "modelJobConnectionLost": "連線已中斷，但伺服器仍在生成。重新連線後會自動取回回應，不需要再次送出",
        "chatStillGenerating": "此對話仍在生成中。請等待生成完成或先停止生成，再重新送出",
        "otherChatGenerating": "另一個對話仍在生成中。請等待生成完成或先停止生成，再重新送出",
        "chatGuardPersistDesc": "伺服器在寫入途中偵測到對話結構損毀，因此拒絕寫入磁碟。您最新的變更可能尚未寫入磁碟；重新整理前請再次確認。現有資料仍然安全",
        "assetManifestConflictTitle": "資源清單已在其他工作階段變更",
        "assetManifestConflictDesc": "已重新載入最新的資源頁面。請確認內容後再重試編輯",
        "chatBodyMissing": "伺服器上找不到這個聊天的內容。為避免用空聊天覆蓋可能仍存在的訊息，已保持原樣。請檢查其他裝置或備份。",
        "chatLoadFailed": "無法載入這個聊天。請檢查連線後重試。",
        "chatLoadRetry": "重新載入",
    },
    "showHelp": "顯示說明",
    "help": helpZhHant,
    "setup": {
        "chooseProvider": "選擇 AI 供應商",
        "openaikey": "使用 OpenAI API 金鑰（推薦）",
        "openaiProxy": "OpenAI 反向代理",
        "setupmodelself": "其他／自行設定",
        "inputApiKey": "在此輸入 API 金鑰",
        "apiKeyhelp": "可從此處取得 API 金鑰：",
        "setupSelfHelp": "歡迎畫面結束後，可前往「設定」自行完成其餘設定",
        "theme": "選擇主題",
        "themeDescWifulike": "不適合行動裝置",
        "themeDescWifuCut": "適合行動裝置",
        "themeDescClassic": "適合所有裝置",
        "texttheme": "選擇文字顏色",
        "inputName": "最後，請輸入您的暱稱",
        "welcome": "歡迎使用 PocketRisu！我是 Airisu，會帶您完成 PocketRisu 的初始設定。首先，我該怎麼稱呼您？",
        "welcome2": "您好，{username}！開始之前，我會先問幾個問題。之後仍可在設定中修改這些選項。\n\n首先請選擇 AI 供應商",
        "openRouterProvider": "OpenRouter 提供來自多家供應商的大量模型，其中部分可免費使用；品質、內容限制與價格會依所選模型與供應商而異",
        "hordeProvider": "Horde 是免費供應商，但回應時間較長、品質也較低",
        "setProviderLater": "還有其他供應商，您可以稍後再到設定中設定。若想之後再處理，請選擇此項",
        "setupOpenAI":
            "若要使用 OpenAI，您需要先取得 API 金鑰。\n1. 前往 https://platform.openai.com/api-keys\n2. 登入 OpenAI Platform\n3. 建立並複製 API 金鑰\n4. 回到 PocketRisu\n5. 貼上金鑰並按下送出按鈕",
        "setupClaude": "若要使用 Claude，您需要先取得 API 金鑰",
        "setupClaudeSteps": [
            "前往此 URL，並使用 Google 帳號登入",
            "填寫您的資訊後按下「Continue」",
            "在 Organization 頁面，只需在第一個欄位填入任意名稱，再按下「Create Account」",
            "按下「Buy Credits」",
            "按下「Complete Setup」",
            "除國家欄位需填入您的國家外，其餘依上方圖片填寫，接著按下「Continue」",
            "加入付款方式後按下「Continue」",
            "完成付款方式設定後，按下「Add Funds」儲值。最低可儲值 5 美元，也可設定自動儲值",
            "儲值完成後回到 Dashboard，按下「Get API Keys」",
            "按下「Create API Key」",
            "依上方圖片填寫後按下「Add」",
            "複製金鑰，貼到這裡後送出",
        ],
        "setupOpenRouter":
            "若要使用 OpenRouter，您需要取得 API 金鑰。\n1. 前往 https://openrouter.ai/keys\n2. 按下「Create Key」\n3. 自行設定金鑰名稱\n4. 複製網站上的金鑰\n5. 回到 PocketRisu\n6. 貼上金鑰並按下送出按鈕",
        "allDone": "全部完成！請稍候片刻",
        "setupLaterMessage": "歡迎，{username}！您想由我帶您完成設定，還是自行設定？",
        "setupMessageOption1": "帶我完成設定",
        "setupMessageOption1Desc": "推薦給新使用者",
        "setupMessageOption2": "我會自行設定",
        "claudeDesc": "Claude 是 Anthropic 開發的 AI 模型，可作為 OpenAI GPT 的替代選擇。實際表現會依模型版本、用途與使用語言而異",
        "openAIDesc": "OpenAI GPT 是 OpenAI 提供的付費 AI 模型；不同模型的能力、價格與內容限制各有不同",
        "chooseChatType": "很好！接著請選擇對話語言模式",
        "chooseChatTypeOption1": "全英文",
        "chooseChatTypeOption1Desc": "AI 會在內部使用英文，並以英文進行輸入與輸出。推薦給英語使用者",
        "chooseChatTypeOption2": "英文處理",
        "chooseChatTypeOption2Desc": "AI 內部會使用英文處理，但輸入／輸出使用您的語言。推薦給非英語使用者",
        "chooseChatTypeOption3": "不指定語言",
        "chooseChatTypeOption3Desc": "AI 內部直接使用您的語言處理，但可能降低品質",
        "chooseCheapOrMemory": "順帶一問，您比較重視記憶能力，還是成本？",
        "chooseCheapOrMemoryOption1": "記憶優先",
        "chooseCheapOrMemoryOption1Desc": "增加 AI 可記住的內容，但成本也會提高",
        "chooseCheapOrMemoryOption2": "成本優先",
        "chooseCheapOrMemoryOption2Desc": "降低記憶量，以節省成本",
        "chooseCheapOrMemoryOption3": "平衡",
        "chooseCheapOrMemoryOption3Desc": "在記憶量與成本之間取得平衡",
        "chooseCheapOrMemoryOption4": "無限制",
        "chooseCheapOrMemoryOption4Desc": "讓 AI 幾乎記住所有內容，但成本會非常高",
        "finally": "最後，您要啟用進階工具嗎？",
        "finallyOption1": "是",
        "finallyOption1Desc": "會啟用進階工具，但 UI 也會更複雜。推薦給進階使用者",
        "finallyOption2": "否",
        "finallyOption2Desc": "會停用進階工具，使 UI 更簡潔。推薦給新使用者",
        "igpPrompt":
            "若 IGP Prompt 有內容，會在主要模型生成回應後，再以情緒模型執行一次 IGP Prompt，並將結果附加在主要模型回應後方",
    },
    "triggerCategories": {
        "Special": "特殊",
        "Control": "控制",
        "Chat": "對話",
        "Low Level": "低階",
        "Alert": "提示",
        "Lorebook V2": "Lorebook V2",
        "String": "字串",
        "Data": "資料",
        "Array": "陣列",
        "Others": "其他",
        "Deprecated": "已棄用",
    },
    "triggerDesc": {
        "v2Header": "標頭",
        "v2HeaderDesc": "標頭",
        "v2If": "如果",
        "v2IfDesc": "如果 {{source}} {{condition}} {{target}}",
        "v2Else": "Else",
        "v2ElseDesc": "Else",
        "v2EndIndent": "結束縮排",
        "v2EndIndentDesc": "結束縮排",
        "v2SetVar": "設定變數",
        "v2SetVarDesc": "設定變數 {{var}} {{operator}} {{value}}",
        "v2Loop": "無限迴圈",
        "v2LoopDesc": "無限迴圈",
        "v2BreakLoop": "跳出迴圈",
        "v2BreakLoopDesc": "跳出迴圈",
        "v2RunTrigger": "執行 Trigger",
        "v2RunTriggerDesc": "執行 Trigger {{target}}",
        "v2ConsoleLog": "主控台輸出",
        "v2ConsoleLogDesc": "將 {{source}} 輸出至主控台",
        "v2StopTrigger": "停止 Trigger",
        "v2StopTriggerDesc": "停止 Trigger",
        "v2CutChat": "截斷對話",
        "v2CutChatDesc": "將對話訊息截取為索引 {{start}} 到 {{end}} 的範圍",
        "v2ModifyChat": "修改對話",
        "v2ModifyChatDesc": "將索引 {{index}} 的訊息內容修改為 {{value}}",
        "v2SystemPrompt": "加入系統提示詞",
        "v2SystemPromptDesc": "在 {{location}} 加入系統提示詞 {{value}}",
        "v2Impersonate": "送出對話",
        "v2ImpersonateDesc": "以 {{role}} 身分送出 {{value}}",
        "v2Command": "執行指令",
        "v2CommandDesc": "以 {{value}} 執行指令",
        "v2SendAIprompt": "送出 AI 提示詞",
        "v2SendAIpromptDesc": "送出 AI 提示詞",
        "v2ImgGen": "圖片生成",
        "v2ImgGenDesc": "以 {{value}} 生成圖片，負面提示詞為 {{negValue}} => {{outputVar}}",
        "v2CheckSimilarity": "檢查相似度",
        "v2CheckSimilarityDesc": "檢查 {{source}} 與 {{value}} 的相似度 => {{outputVar}}",
        "v2RunLLM": "執行模型",
        "v2RunLLMDesc": "以 {{value}} 向模型送出請求 => {{outputVar}}",
        "v2ShowAlert": "顯示提示",
        "v2ShowAlertDesc": "顯示內容為 {{value}} 的提示",
        "v2ExtractRegex": "Regex 擷取",
        "v2ExtractRegexDesc":
            "使用 Regex {{regexType}} {{regex}} 與旗標 {{flagsType}} {{flags}} 從 {{value}} 擷取文字，並將結果以 {{resultType}} {{result}} 儲存 => {{outputVar}}",
        "v2RegexTest": "Regex 測試",
        "v2RegexTestDesc": "以 Regex {{regex}} 與旗標 {{flags}} 測試 {{value}} => {{outputVar}}",
        "v2GetLastMessage": "取得最後一則訊息",
        "v2GetLastMessageDesc": "取得最後一則訊息 => {{outputVar}}",
        "v2GetMessageAtIndex": "取得指定索引訊息",
        "v2GetMessageAtIndexDesc": "取得索引 {{index}} 的訊息 => {{outputVar}}",
        "v2GetMessageCount": "取得訊息數量",
        "v2GetMessageCountDesc": "取得訊息數量 => {{outputVar}}",
        "v2GetLorebook": "取得 Lorebook",
        "v2GetLorebookDesc": "取得名為 {{target}} 的 Lorebook => {{outputVar}}",
        "v2GetLorebookCount": "取得 Lorebook 數量",
        "v2GetLorebookCountDesc": "取得 Lorebook 數量 => {{outputVar}}",
        "v2GetLorebookEntry": "依索引取得 Lorebook",
        "v2GetLorebookEntryDesc": "取得索引 {{index}} 的 Lorebook => {{outputVar}}",
        "v2SetLorebookActivation": "設定 Lorebook 啟用狀態",
        "v2SetLorebookActivationDesc": "將索引 {{index}} 的 Lorebook 啟用狀態設為 {{value}}",
        "v2GetLorebookIndexViaName": "依名稱取得 Lorebook 索引",
        "v2GetLorebookIndexViaNameDesc": "依名稱 {{name}} 取得 Lorebook 索引 => {{outputVar}}",
        "v2ModifyLorebook": "修改 Lorebook",
        "v2ModifyLorebookDesc": "以 {{value}} 修改名為 {{target}} 的 Lorebook",
        "v2LoopNTimes": "迴圈 N 次",
        "v2LoopNTimesDesc": "迴圈 {{value}} 次",
        "v2Random": "隨機數",
        "v2RandomDesc": "從 {{min}} 到 {{max}} 隨機取值 => {{outputVar}}",
        "v2GetCharAt": "取得指定索引字元",
        "v2GetCharAtDesc": "取得 {{source}} 中索引 {{index}} 的字元 => {{outputVar}}",
        "v2GetCharCount": "取得字元數量",
        "v2GetCharCountDesc": "取得 {{source}} 的字元數量 => {{outputVar}}",
        "v2ToLowerCase": "轉為小寫",
        "v2ToLowerCaseDesc": "將 {{source}} 轉為小寫 => {{outputVar}}",
        "v2ToUpperCase": "轉為大寫",
        "v2ToUpperCaseDesc": "將 {{source}} 轉為大寫 => {{outputVar}}",
        "v2SetCharAt": "設定指定索引字元",
        "v2SetCharAtDesc": "將 {{source}} 中索引 {{index}} 的字元設為 {{value}} => {{outputVar}}",
        "v2SplitString": "分割字串",
        "v2SplitStringDesc": "以 {{delimiter}} 分割 {{source}} => {{outputVar}}",
        "v2GetCharacterDesc": "取得角色描述",
        "v2GetCharacterDescDesc": "取得角色描述 => {{outputVar}}",
        "v2SetCharacterDesc": "設定角色描述",
        "v2SetCharacterDescDesc": "將角色描述設為 {{value}}",
        "v2GetPersonaDesc": "取得使用者人設",
        "v2GetPersonaDescDesc": "取得使用者人設 => {{outputVar}}",
        "v2SetPersonaDesc": "設定使用者人設",
        "v2SetPersonaDescDesc": "將使用者人設設為 {{value}}",
        "v2GetReplaceGlobalNote": "取得全域備註替換",
        "v2GetReplaceGlobalNoteDesc": "取得全域備註替換 => {{outputVar}}",
        "v2SetReplaceGlobalNote": "設定全域備註替換",
        "v2SetReplaceGlobalNoteDesc": "將全域備註替換設為 {{value}}",
        "v2GetAuthorNote": "取得作者備註",
        "v2GetAuthorNoteDesc": "取得作者備註 => {{outputVar}}",
        "v2SetAuthorNote": "設定作者備註",
        "v2SetAuthorNoteDesc": "將作者備註設為 {{value}}",
        "v2Comment": "加入註解",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "宣告區域變數",
        "v2DeclareLocalVarDesc": "宣告區域變數 {{var}}，值為 {{value}}",
        "v2MakeArrayVar": "建立陣列變數",
        "v2MakeArrayVarDesc": "建立陣列變數 {{var}}",
        "v2GetArrayVarLength": "取得陣列變數長度",
        "v2GetArrayVarLengthDesc": "取得陣列變數 {{var}} 的長度 => {{outputVar}}",
        "v2GetArrayVar": "取得陣列變數",
        "v2GetArrayVarDesc": "取得陣列變數 {{var}} 中索引 {{index}} 的值 => {{outputVar}}",
        "v2SetArrayVar": "設定陣列變數",
        "v2SetArrayVarDesc": "將陣列變數 {{var}} 中索引 {{index}} 的值設為 {{value}}",
        "v2PushArrayVar": "加入陣列變數",
        "v2PushArrayVarDesc": "將 {{value}} 加入陣列變數 {{var}}",
        "v2PopArrayVar": "移除並取得陣列最後一個值",
        "v2PopArrayVarDesc": "移除陣列變數 {{var}} 的最後一個值 => {{outputVar}}",
        "v2ShiftArrayVar": "移除並取得陣列第一個值",
        "v2ShiftArrayVarDesc": "移除陣列變數 {{var}} 的第一個值 => {{outputVar}}",
        "v2UnshiftArrayVar": "將值加入陣列開頭",
        "v2UnshiftArrayVarDesc": "將 {{value}} 加到陣列變數 {{var}} 的第一個位置",
        "v2SpliceArrayVar": "在陣列指定位置插入值",
        "v2SpliceArrayVarDesc": "將 {{value}} 插入陣列變數 {{var}} 的索引 {{start}}",
        "v2SliceArrayVar": "擷取陣列片段",
        "v2SliceArrayVarDesc": "擷取陣列變數 {{var}} 從 {{start}} 到 {{end}} 的片段 => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "取得陣列中指定值的索引",
        "v2GetIndexOfValueInArrayVarDesc": "取得陣列變數 {{var}} 中 {{value}} 的索引 => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "移除陣列指定索引",
        "v2RemoveIndexFromArrayVarDesc": "移除陣列變數 {{var}} 中索引 {{index}} 的值",
        "v2JoinArrayVar": "將陣列串接為字串",
        "v2JoinArrayVarDesc": "以 {{delimiter}} 串接陣列 {{var}} 的元素 => {{outputVar}}",
        "v2MakeDictVar": "建立字典變數",
        "v2MakeDictVarDesc": "建立字典變數 {{var}}",
        "v2GetDictVar": "取得字典值",
        "v2GetDictVarDesc": "取得字典 {{var}} 中鍵 {{key}} 的值 => {{outputVar}}",
        "v2SetDictVar": "設定字典值",
        "v2SetDictVarDesc": "將字典 {{var}} 中鍵 {{key}} 的值設為 {{value}}",
        "v2DeleteDictKey": "刪除字典鍵",
        "v2DeleteDictKeyDesc": "從字典 {{var}} 刪除鍵 {{key}}",
        "v2HasDictKey": "檢查字典鍵",
        "v2HasDictKeyDesc": "檢查字典 {{var}} 是否包含鍵 {{key}} => {{outputVar}}",
        "v2ClearDict": "清空字典",
        "v2ClearDictDesc": "清空字典 {{var}}",
        "v2GetDictSize": "取得字典項目數",
        "v2GetDictSizeDesc": "取得字典 {{var}} 的項目數 => {{outputVar}}",
        "v2GetDictKeys": "取得字典所有鍵",
        "v2GetDictKeysDesc": "取得字典 {{var}} 的所有鍵 => {{outputVar}}",
        "v2GetDictValues": "取得字典所有值",
        "v2GetDictValuesDesc": "取得字典 {{var}} 的所有值 => {{outputVar}}",
        "v2ConcatString": "串接字串",
        "v2ConcatStringDesc": "串接 {{source1}} 與 {{source2}} => {{outputVar}}",
        "v2GetLastUserMessage": "取得最後一則使用者訊息",
        "v2GetLastUserMessageDesc": "取得最後一則使用者訊息 => {{outputVar}}",
        "v2GetLastCharMessage": "取得最後一則角色訊息",
        "v2GetLastCharMessageDesc": "取得最後一則角色訊息 => {{outputVar}}",
        "v2GetFirstMessage": "取得第一則訊息",
        "v2GetFirstMessageDesc": "取得第一則訊息 => {{outputVar}}",
        "v2GetAlertInput": "取得提示視窗輸入值",
        "v2GetAlertInputDesc": "顯示輸入提示視窗並將結果儲存至 {{outputVar}}",
        "v2GetAlertSelect": "取得提示視窗選取結果",
        "v2GetAlertSelectDesc": "顯示 {{display}}，提供選項 {{value}}，並將選取結果儲存至 {{outputVar}}",
        "v2UnsupportedTrigger": "不支援的 Trigger",
        "v2UnsupportedTriggerDesc": "不支援的 Trigger",
        "v2GetDisplayState": "取得顯示狀態",
        "v2GetDisplayStateDesc": "取得顯示狀態 => {{outputVar}}",
        "v2SetDisplayState": "設定顯示狀態",
        "v2SetDisplayStateDesc": "將顯示狀態設為 {{value}}",
        "v2UpdateGUI": "更新 GUI",
        "v2UpdateGUIDesc": "更新 GUI",
        "v2UpdateChatAt": "更新指定索引對話",
        "v2UpdateChatAtDesc": "重新繪製索引 {{index}} 的對話",
        "v2Wait": "等待",
        "v2WaitDesc": "等待 {{value}} 秒",
        "v2GetRequestState": "取得請求資料內容",
        "v2GetRequestStateDesc": "取得索引 {{index}} 的請求內容 => {{outputVar}}",
        "v2SetRequestState": "設定請求資料內容",
        "v2SetRequestStateDesc": "將索引 {{index}} 的請求內容設為 {{value}}",
        "v2GetRequestStateRole": "取得請求資料身分",
        "v2GetRequestStateRoleDesc": "取得索引 {{index}} 的請求資料身分 => {{outputVar}}",
        "v2SetRequestStateRole": "設定請求資料身分",
        "v2SetRequestStateRoleDesc": "將索引 {{index}} 的請求資料身分設為 {{value}}",
        "v2GetRequestStateLength": "取得請求資料長度",
        "v2GetRequestStateLengthDesc": "取得請求資料長度 => {{outputVar}}",
        "v2IfAdvanced": "如果",
        "v2IfAdvancedDesc": "如果 {{source}} {{condition}} {{target}}",
        "v2QuickSearchChat": "快速搜尋對話",
        "v2QuickSearchChatDesc": "以 {{condition}} 條件在深度 {{depth}} 的對話中快速搜尋 {{value}} => {{outputVar}}",
        "v2StopPromptSending": "停止送出提示詞",
        "v2StopPromptSendingDesc": "停止送出提示詞",
        "v2Tokenize": "計算 Token 數",
        "v2TokenizeDesc": "計算 {{value}} 的 Token 數 => {{outputVar}}",
        "v2GetAllLorebooks": "取得所有 Lorebook",
        "v2GetAllLorebooksDesc": "取得所有 Lorebook 提示詞並組成陣列 => {{outputVar}}",
        "v2GetLorebookByName": "依名稱取得 Lorebook 索引",
        "v2GetLorebookByNameDesc": "依名稱 {{name}} 取得 Lorebook 索引陣列 => {{outputVar}}",
        "v2GetLorebookByIndex": "取得 Lorebook",
        "v2GetLorebookByIndexDesc": "取得索引 {{index}} 的 Lorebook 提示詞 => {{outputVar}}",
        "v2CreateLorebook": "建立 Lorebook",
        "v2CreateLorebookDesc": "建立 Lorebook：名稱 {{name}}、啟用關鍵字 {{key}}、內容 {{content}}",
        "v2ModifyLorebookByIndex": "修改 Lorebook",
        "v2ModifyLorebookByIndexDesc": "修改索引 {{index}} 的 Lorebook：名稱 {{name}}、啟用關鍵字 {{key}}、內容 {{content}}",
        "v2DeleteLorebookByIndex": "刪除 Lorebook",
        "v2DeleteLorebookByIndexDesc": "刪除索引 {{index}} 的 Lorebook",
        "v2GetLorebookCountNew": "取得 Lorebook 數量",
        "v2GetLorebookCountNewDesc": "取得 Lorebook 總數 => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "設定 Lorebook 一律啟用",
        "v2SetLorebookAlwaysActiveDesc": "將索引 {{index}} 的 Lorebook「一律啟用」設為 {{value}}",
        "v2Calculate": "計算",
        "v2CalculateDesc": "計算 {{expression}} => {{outputVar}}",
        "v2ReplaceString": "替換字串",
        "v2ReplaceStringDesc": "以 Regex {{regex}} 將 {{source}} 替換為 {{replacement}} => {{outputVar}}",
    },
    "triggerInputLabels": {
        "value": "值",
        "var": "變數",
        "varName": "變數名稱",
        "outputVar": "輸出變數",
        "name": "名稱",
        "index": "索引",
        "source": "來源",
        "target": "目標",
        "condition": "條件",
        "operator": "運算子",
        "role": "身分",
        "location": "位置",
        "prompt": "提示詞",
        "model": "模型",
        "start": "開始",
        "end": "結束",
        "min": "最小值",
        "max": "最大值",
        "delimiter": "分隔符號",
        "depth": "深度",
        "key": "鍵",
        "alertContent": "提示內容",
        "options": "選項",
        "cmd": "指令",
        "regex": "Regex",
        "replacement": "替換內容",
        "flags": "旗標",
        "negPrompt": "負面提示詞",
        "resultFormat": "結果格式",
        "activationKeys": "啟用關鍵字",
        "insertOrder": "插入順序",
        "sysStart": "系統開始",
        "sysHistoryEnd": "系統歷史結束",
        "sysPromptEnd": "系統提示詞結束",
        "addElse": "加入 Else",
        "alwaysActive": "一律啟用",
        "trigger": "Trigger",
        "triggerOn": "Trigger 時機",
        "valueTypeDesc": "直接使用輸入值",
        "varTypeDesc": "使用變數中儲存的值",
        "conditionEqual": "等於 (=)",
        "conditionNotEqual": "不等於 (≠)",
        "conditionGreater": "大於 (>)",
        "conditionLess": "小於 (<)",
        "conditionGreaterEqual": "大於等於 (≥)",
        "conditionLessEqual": "小於等於 (≤)",
        "conditionSimilar": "相似 (≒)",
        "conditionContains": "包含 (∋)",
        "conditionIn": "屬於 (∈)",
        "conditionNotContains": "不包含 (∌)",
        "conditionNotIn": "不屬於 (∉)",
        "conditionTruthy": "Truthy (≡)",
        "operatorSet": "設定 (=)",
        "operatorAdd": "加上 (+=)",
        "operatorSubtract": "減去 (-=)",
        "operatorMultiply": "乘上 (*=)",
        "operatorDivide": "除以 (/=)",
        "operatorModulo": "取餘數 (%=)",
        "searchLoose": "寬鬆搜尋",
        "searchStrict": "嚴格搜尋",
        "searchRegex": "Regex 搜尋",
        "modelMain": "主要模型",
        "modelSub": "輔助模型",
        "roleUser": "user",
        "roleChar": "char",
        "roleSystem": "system",
        "roleAssistant": "assistant",
        "boolTrue": "True",
        "boolFalse": "False",
        "boolNull": "Null",
        "helpVarName": "輸入變數名稱",
        "helpOutputVar": "輸入用來儲存結果的變數名稱",
        "helpIndex": "陣列或訊息索引編號",
        "helpRegex": "輸入 Regex",
        "helpFlags": "Regex 旗標",
        "helpDelimiter": "分割字串時使用的分隔符號",
        "helpActivationKeys": "以逗號分隔的啟用關鍵字",
        "helpInsertOrder": "插入順序",
        "helpDepth": "搜尋訊息的深度",
        "helpMinMax": "最小值與最大值範圍",
        "helpSlot": "使用 {{slot}} 保持原值不變",
        "expression": "運算式",
    },
    "playground": {
        "playground": "Playground",
        "inlayDeleteSelected": "刪除已選項目",
        "inlayDeselectAll": "取消所有選取",
        "inlayEmpty": "沒有已儲存的內嵌資源",
        "inlayEmptyDesc": "對話中附加或生成的圖片、音訊與影片會顯示在這裡",
        "inlayExplorer": "內嵌資源瀏覽器",
        "inlayImageGallery": "內嵌圖片庫",
        "inlayImageGalleryEmptyDesc": "對話中附加或生成的圖片會顯示在這裡",
        "inlayImageList": "圖片清單",
        "inlaySelectAll": "全部選取",
        "inlayDeleteConfirm": "確定要刪除 {name} 嗎？",
        "inlayDeleteMultipleConfirm": "確定要刪除已選取的 {count} 個資源嗎？",
        "inlayTotalAssets": "共 {count} 個資源",
        "inlayDelete": "刪除",
        "inlayLoadingMore": "載入中...",
        "inlayCreatedAt": "建立時間：",
        "inlayUpdatedAt": "更新時間：",
        "inlaySort": "排序",
        "inlaySortUpdatedDesc": "更新時間 ↓",
        "inlaySortUpdatedAsc": "更新時間 ↑",
        "inlaySortCreatedDesc": "建立時間 ↓",
        "inlaySortCreatedAsc": "建立時間 ↑",
        "inlayFilter": "篩選",
        "inlayFilterAll": "全部",
        "inlayFilterMetaMissing": "缺少中繼資料",
        "inlayFilterOrphanCharacter": "無對應角色",
        "inlayFilterOrphanChat": "無對應對話",
        "inlayOriginalLoadNeeded": "需要載入原始檔",
        "inlayAudioAsset": "音訊資源",
        "inlayVideoAsset": "影片資源",
        "inlaySignatureAsset": "簽名資源",
        "inlayInfo": "資訊",
        "inlayManualMapping": "手動對應",
        "inlayActions": "操作",
        "inlayLoadingOriginal": "正在載入原始圖片...",
        "inlaySave": "儲存",
        "inlaySaved": "已儲存！",
        "inlayFilterOrphanMessage": "未被訊息引用",
        "inlayScanMessages": "掃描訊息",
        "inlayScanning": "掃描中...",
        "inlayScanFailed": "訊息掃描失敗；不會顯示未被引用的項目清單",
        "inlayDeleteSkippedReferenced": "重新掃描後發現其中 {count} 個再次被引用，因此未刪除這些項目",
        "inlayScanDone": "已掃描 {count} 則訊息",
    },
    "confirm": "確認",
    "yes": "是",
    "no": "否",
    "goback": "返回",
    "botSettings": "Bot 設定",
    "model": "模型",
    "apiKey": "API 金鑰",
    "providerURL": "請求 URL",
    "providerJSON": "Request Body（JSON）",
    "mainPrompt": "主要提示詞",
    "jailbreakPrompt": "越獄提示詞",
    "globalNote": "全域備註",
    "autoSuggest": "自動建議",
    "tokens": "Token",
    "maxContextSize": "最大上下文長度",
    "maxResponseSize": "最大回應長度",
    "temperature": "Temperature",
    "frequencyPenalty": "Frequency Penalty",
    "presensePenalty": "Presence Penalty",
    "advancedSettings": "進階設定",
    "advancedSettingsWarn": "警告：若您不知道某個選項的用途，請勿修改！",
    "formatingOrder": "提示詞排列順序",
    "authorNote": "作者備註",
    "firstMessage": "開局訊息",
    "description": "描述",
    "note": "備註",
    "jailbreakToggle": "越獄開關",
    "charIcon": "角色圖示",
    "characterDisplay": "角色顯示",
    "viewScreen": "額外角色畫面",
    "none": "無",
    "emotionImage": "情緒立繪",
    "noImages": "沒有圖片",
    "noBias": "未設定 Bias",
    "image": "圖片",
    "name": "名稱",
    "characterName": "角色名稱",
    "characterInfo": "角色資訊",
    "folderName": "資料夾名稱",
    "folderRemoveConfirm": "此資料夾包含 Lorebook。確定要刪除此資料夾及其中所有內容嗎？",
    "emotion": "情緒名稱",
    "value": "值",
    "reroll": "重新生成",
    "hideMessagePageCount": "隱藏訊息分頁計數",
    "deleteRerollMessage": "刪除重新生成的訊息",
    "deleteRerollMessageConfirm": "要刪除目前選取的重新生成訊息嗎？",
    "rerollConfirm": "要生成新訊息並加入清單嗎？",
    "noSwipesRerollConfirm": "沒有其他重新生成的訊息。要生成新訊息並加入清單嗎？",
    "chatList": "對話清單",
    "removeChat": "要移除此訊息嗎？",
    "loreBook": "Lorebook",
    "character": "角色",
    "Chat": "對話",
    "globalLoreInfo": "角色 Lorebook 會套用至此角色的所有對話",
    "group": "群組",
    "localLoreInfo": "對話 Lorebook 只套用至目前對話",
    "removeConfirm": "確定要移除：",
    "removeConfirm2": "真的確定要移除：",
    "exportConfirm": "要匯出此項目嗎？",
    "insertOrder": "插入順序",
    "activationKeys": "啟用關鍵字",
    "activationKeysInfo": "以逗號分隔",
    "prompt": "提示詞",
    "loreBookDepth": "Lorebook 搜尋深度",
    "loreBookToken": "Lorebook 最大 Token",
    "chatLoadInitialPages": "初始對話載入數量",
    "chatLoadAdditionalPages": "額外對話載入數量",
    "removeCharacter": "移除角色",
    "deactivateCharacter": "停用角色",
    "deactivateCharacterConfirm": (name: string) =>
        `要停用「${name}」及其對話嗎？

停用不常使用的角色可減少載入與儲存負擔，有助於改善效能。角色仍會保留在清單中，但無法開啟；外掛、腳本、搜尋與資料集匯出會將其視為已刪除。其資料會保留在伺服器上，之後可隨時重新啟用。

要停用嗎？`,
    "deactivateCharacterDone": "角色已停用",
    "deactivateCharacterFailed": "停用失敗：",
    "rebaseSkippedArchived": (names: string) =>
        `「${names}」已在其他裝置停用，因此此裝置上尚未儲存的編輯內容已捨棄`,
    "activateCharacterConfirm": (name: string) => `「${name}」已停用。要重新啟用嗎？`,
    "activateCharacterMissing": "找不到已儲存的角色資料，因此無法啟用。請檢查伺服器記錄與儲存空間儀表板",
    "activateCharacterFailed": "啟用失敗：",
    "activateCharacterRemoveStub": "要從清單中移除此角色嗎？（不會刪除其他資料）",
    "deactivatedBadge": "已停用",
    "exportCharacter": "匯出角色",
    "characterPackage": "角色套件",
    "characterPackageExport": "匯出套件",
    "convertToModule": "轉換為模組",
    "convertToCharacter": "轉換為角色",
    "successfullyConverted": "轉換成功",
    "characterPackageImport": "匯入角色套件（ZIP）",
    "characterPackageCharacter": "角色",
    "characterPackageChats": "對話",
    "characterPackagePersona": "使用者人設",
    "characterPackageInlays": "內嵌圖片",
    "characterPackageNone": "無",
    "characterPackageChatCount": "",
    "characterPackageInlayCount": "",
    "characterPackageExportSuccess": "已成功匯出角色套件",
    "characterPackageImportSuccess": "已成功匯入角色套件",
    "characterPackageImportSummary": "套件內容",
    "characterPackageInvalidZip": "無效的角色套件檔案",
    "characterPackageProgressCharacter": "正在建立角色...",
    "characterPackageProgressChats": "正在寫入對話...",
    "characterPackageProgressPersona": "正在寫入使用者人設...",
    "characterPackageProgressInlays": "正在寫入內嵌圖片...",
    "characterPackageProgressFinalizing": "正在進行最後處理...",
    "characterPackageProgressReading": "正在讀取套件...",
    "characterPackageProgressImportChar": "正在匯入角色...",
    "characterPackageProgressImportPersona": "正在匯入使用者人設...",
    "characterPackageProgressImportChats": "正在匯入對話...",
    "characterPackageProgressImportInlays": "正在匯入內嵌圖片...",
    "characterPackageEmpty": "空白角色",
    "characterPackageEmptyWarning": "角色資料為空。仍要匯入嗎？",
    "characterPackageNameMismatch": "角色名稱不一致。仍要匯入嗎？",
    "characterPackageImportToChar": "將套件匯入角色",
    "characterPackageLicenseWarning": "角色匯出受到授權條款限制",
    "characterPackageCheckCount": "檢查",
    "userSetting": "使用者設定",
    "username": "您的名字",
    "userIcon": "您的圖示",
    "successExport": "匯出成功，檔案已下載至您的下載資料夾",
    "successImport": "匯入成功",
    "moduleCreated": "已建立模組",
    "moduleUpdated": "已更新模組",
    "moduleDeleted": "已刪除模組",
    "importedCharacter": "已匯入角色",
    "alwaysActive": "一律啟用",
    "additionalPrompt": "額外提示詞",
    "descriptionPrefix": "描述前綴",
    "forceReplaceUrl": "反向代理",
    "emotionWarn": "會使用輔助模型",
    "plugin": "外掛",
    "language": "語言",
    "UiLanguage": "UI 語言",
    "createfromScratch": "從空白建立",
    "importCharacter": "匯入角色",
    "translator": "翻譯器",
    "disabled": "已停用",
    "noPluginSelected": "已選擇外掛模型，但尚未選擇外掛",
    "text": "文字",
    "UISize": "介面縮放比例",
    "newVersion": "發現更新，要立即安裝嗎？",
    "updateAvailable": "v{{version}} 有更新可用",
    "updateRequired": "v{{version}} 必須更新",
    "updateOutdated": "v{{version}} — 您目前的版本過舊",
    "statsUsersToday": "今日 {{count}} 位使用者",
    "statsYesterday": "昨日 {{count}} 位",
    "statsVisitsToday": "今日 {{count}} 次造訪",
    "updatePopupTitle": "有更新可用",
    "updatePopupTitleRequired": "必須更新",
    "updatePopupTitleOutdated": "版本過舊",
    "updatePopupDesc": "已有新版本 <b>v{{latest}}</b> 可用。（目前版本：v{{current}}）",
    "updatePopupViewRelease": "查看版本說明",
    "updatePopupLater": "稍後",
    "selfUpdateNow": "立即更新",
    "selfUpdateInProgress": "更新中...",
    "selfUpdateDone": "更新完成",
    "selfUpdateFailed": "更新失敗",
    "selfUpdateReloadHint": "請重新整理頁面以使用新版本",
    "selfUpdateReload": "重新整理",
    "close": "關閉",
    "remindLaterQuestion": "要在什麼時候再次提醒？",
    "remindIgnore": "忽略",
    "remindLater1Day": "1 天後提醒",
    "remindLater3Days": "3 天後提醒",
    "remindLater5Days": "5 天後提醒",
    "remindLater1Week": "1 週後提醒",
    "display": "顯示與音訊",
    "useCustomBackground": "自訂背景",
    "translateInput": "翻譯輸入",
    "autoTranslation": "自動翻譯",
    "fullscreen": "全螢幕（不建議使用）",
    "playMessage": "播放訊息音訊",
    "iconSize": "圖示大小",
    "single": "單一",
    "multiple": "多個",
    "useCharLorebook": "使用角色 Lorebook",
    "selectChar": "選擇角色",
    "askLoadFirstMsg": "要載入開局訊息嗎？",
    "theme": "主題",
    "editOrder": "編輯順序",
    "submodel": "輔助模型",
    "timeOutinSec": "逾時（秒）",
    "emotionPrompt": "情緒提示詞",
    "singleView": "單角色檢視",
    "SpacedView": "多角色檢視",
    "emphasizedView": "雙角色檢視",
    "pluginWarn": "安裝惡意外掛可能造成安全問題",
    "pluginConfirm": "確定要匯入此外掛嗎？請只匯入來自可信來源的外掛",
    "pluginContainsExternalMedia": "此外掛包含外部媒體",
    "pluginContainsExternalJS": "此外掛包含外部 JavaScript",
    "waifuWidth": "Waifulike 對話區域寬度",
    "files": "檔案",
    "backupConfirm": "確定要儲存備份嗎？",
    "backupLoadConfirm": "確定要載入備份嗎？目前資料將由備份內容覆寫！",
    "backupLoadConfirm2": "再次確認：真的要載入備份嗎？目前資料將由備份內容覆寫！",
    "others": "其他",
    "sectionInterface": "介面",
    "sectionHomeList": "首頁與對話清單",
    "sectionChatView": "對話畫面",
    "sectionBubble": "訊息泡泡",
    "sectionQuotes": "引號",
    "sectionAdvanced": "進階",
    "accTabEditing": "編輯",
    "accTabScroll": "捲動",
    "accTabSidebar": "側邊欄",
    "presets": "預設集",
    "themePresets": "介面主題預設集",
    "imageGeneration": "圖片生成",
    "provider": "供應商",
    "key": "金鑰",
    "noData": "沒有資料",
    "currentImageGeneration": "目前圖片生成資料",
    "promptPreprocess": "啟用提示詞預處理（Prompt Preprocess）",
    "SwipeRegenerate": "使用滑動重新生成",
    "removeMessageOnly": "只刪除這則訊息",
    "removeMessageAndAfter": "刪除這則及之後的訊息（{} 則）",
    "messageRemoved": "已刪除訊息",
    "messagesRemoved": "已刪除 {} 則訊息",
    "confirmReroll": "重新生成訊息前先確認",
    "textColor": "文字顏色",
    "classicRisu": "Classic Risu",
    "highcontrast": "高對比",
    "requestretrys": "請求失敗時的重試次數",
    "utilityBot": "工具型 Bot",
    "waifuWidth2": "Waifulike 角色立繪區域寬度",
    "nodeOnlyStandardChatWidth": "對話寬度",
    "chatWidthStandard": "標準",
    "chatWidthWide": "加寬",
    "chatWidthFull": "不限寬度",
    "customCSSWarning": "PocketRisu 的 UI 結構（HTML／CSS）與上游 Risuai 不同，因此既有的自訂 CSS 可能造成版面錯亂或非預期行為。請只在了解覆寫內容時使用",
    "customHTMLWarning": "PocketRisu 的 UI 結構（HTML／CSS）與上游 Risuai 不同，因此既有的自訂對話 HTML 可能無法正確顯示。請只在了解覆寫內容時使用",
    "sayNothing": "沒有輸入文字時送出「say nothing」",
    "regexScript": "Regex 腳本",
    "type": "類型",
    "editInput": "修改輸入",
    "editOutput": "修改輸出",
    "editProcess": "修改請求資料",
    "loadLatest": "載入最新備份",
    "loadOthers": "載入其他備份",
    "exampleMessage": "示範對話",
    "creatorNotes": "創作者留言",
    "systemPrompt": "系統提示詞",
    "characterNotes": "角色備註",
    "personality": "性格",
    "scenario": "情境",
    "alternateGreetings": "替代開局訊息",
    "unrecommended": "不建議使用",
    "chatNotes": "對話備註",
    "showUnrecommended": "顯示不建議使用的設定",
    "streamingDisplayOptimizationMode": "串流顯示最佳化",
    "streamingDisplayOptimizationOff": "關閉（每個 Token 都更新）",
    "streamingDisplayOptimizationOffDesc": "每收到一個 Token 都重新繪製畫面並執行腳本",
    "streamingDisplayOptimizationBalanced": "約每 0.125 秒更新",
    "streamingDisplayOptimizationBalancedDesc": "將重新繪製合併為約每 0.125 秒執行一次，以降低負載",
    "streamingDisplayOptimizationStrong": "完成後套用",
    "streamingDisplayOptimizationStrongDesc": "串流期間顯示原始文字，結束後再執行一次腳本",
    "allowV2Plugin": "允許已棄用的 V2.0 外掛",
    "allowV21Plugin": "允許安裝已棄用的 V2.1 外掛",
    "altGreet": "替代開局訊息",
    "scripts": "腳本",
    "settings": "設定",
    "selective": "選擇性",
    "SecondaryKeys": "次要關鍵字",
    "useGlobalSettings": "使用全域設定",
    "recursiveScanning": "遞迴掃描",
    "creator": "創作者",
    "CharVersion": "角色版本",
    "Speech": "語音",
    "useExperimental": "啟用實驗性功能",
    "showMemoryLimit": "顯示記憶上限",
    "showFirstMessagePages": "顯示開局訊息分頁",
    "roundIcons": "圓形圖示",
    "streaming": "串流",
    "chatBot": "聊天 Bot",
    "modelPresetMenu": "模型預設集",
    "promptPresetMenu": "提示詞",
    "botSettingsLegacyTitle": "「聊天 Bot」是舊版功能",
    "botSettingsLegacyDesc": "此處的模型更新可能較慢，新功能也可能不會套用。請使用「模型預設集」以取得最新模型與功能",
    "botSettingsPresetMovedDesc": "預設集已移至「提示詞」選單",
    "botSettingsParamScopeDesc": "此頁面的參數只會套用至「聊天 Bot」中選取的模型。若使用模型預設集，請在該預設集中調整參數",
    "botSettingsCustomFlagsScopeDesc": "自訂旗標只會套用至舊版模型。模型預設集會依模型設定檔自動套用對應的模型能力",
    "currentThemePreset": "目前的介面主題預設集",
    "currentPromptPreset": "目前的提示詞預設集",
    "presetDuplicate": "建立副本",
    "presetExport": "匯出",
    "presetImport": "匯入",
    "presetNew": "新增預設集",
    "presetManage": "管理預設集",
    "moduleManage": "管理模組",
    "pluginImport": "匯入外掛",
    "pluginDevTools": "開發者工具",
    "presetDelete": "刪除",
    "presetDuplicated": "已建立預設集副本",
    "presetExported": "已匯出預設集",
    "presetImported": "已匯入預設集",
    "presetDeleted": "已刪除預設集",
    "presetDeleteConfirm": "要刪除此預設集嗎？",
    "recoveredPresetName": "已復原的預設集",
    "recoveredPresetNotice": "找不到所選的提示詞預設集，已將目前設定儲存為「已復原的預設集」",
    "iconRemove": "移除圖示",
    "otherBots": "其他 Bot",
    "user": "使用者",
    "additionalAssets": "額外資源",
    "viewInAssetViewer": "在資源檢視器中查看",
    "editDisplay": "修改顯示",
    "textBackgrounds": "自訂文字區域顏色",
    "textBorder": "文字外框",
    "textScreenRound": "圓角文字區域",
    "textScreenBorder": "文字區域邊框",
    "ttsReadOnlyQuoted": "只朗讀引號內容",
    "ttsStop": "停止 TTS",
    "replaceGlobalNote": "全域備註替換",
    "charLoreBook": "角色 Lorebook",
    "globalLoreBook": "全域 Lorebook",
    "globalRegexScript": "全域 Regex",
    "accessibility": "無障礙",
    "sendWithEnter": "使用 Enter 鍵送出",
    "sendKeyPC": "送出鍵（電腦）",
    "sendKeyMobile": "送出鍵（行動裝置）",
    "chatInputExpandTitle": "訊息輸入框",
    "resendLastMessage": "重新送出上一則訊息",
    "enterMessagePlaceholder": "輸入訊息...",
    "enterMessageToPersona": (name: string) => `傳送訊息給 ${name}...`,
    "sendKeyEnter": "Enter（Shift+Enter 換行）",
    "sendKeyCtrlEnter": "Ctrl+Enter（Enter 換行）",
    "sendKeyShiftEnter": "Shift+Enter（Enter 換行）",
    "sendKeyButton": "僅使用送出按鈕（Enter 換行）",
    "fixedChatTextarea": "將對話輸入框固定在底部",
    "clickToEdit": "按一下文字以編輯",
    "enableBlockPartialEdit": "啟用區塊局部編輯（滑鼠移至個別區塊即可編輯）",
    "enableDragPartialEdit": "啟用拖曳局部編輯（選取文字即可編輯）",
    "setNodePassword": "設定密碼以提升安全性",
    "inputNodePassword": "輸入您的密碼。若忘記密碼，請刪除伺服器檔案中的 save/__password.txt 後重新啟動伺服器",
    "simple": "簡易",
    "advanced": "進階",
    "askReRollAutoSuggestions": "重新生成自動建議",
    "creatingSuggestions": "正在生成建議...",
    "active": "啟用",
    "loreRandomActivation": "使用機率條件",
    "activationProbability": "機率",
    "hub": "RisuRealm",
    "tags": "標籤",
    "backgroundHTML": "對話背景 HTML",
    "copied": "已複製",
    "useChatCopy": "啟用對話訊息複製",
    "useChatSticker": "使用對話貼圖",
    "useAdditionalAssetsPreview": "使用額外資源預覽",
    "autoTranslateInput": "自動翻譯輸入",
    "enterMessageForTranslateToEnglish": "輸入要翻譯成英文的訊息",
    "recent": "最近",
    "downloads": "下載",
    "trending": "熱門",
    "imageCompression": "圖片壓縮",
    "inlayImageLossless": "以無損格式儲存內嵌圖片",
    "inlayImagePriority": "優先顯示內嵌圖片",
    "inlayCompressAll": "壓縮所有內嵌圖片",
    "inlayCompressing": "壓縮中...",
    "inlayCompressConfirm": "所有內嵌圖片都會壓縮為 WebP，且無法復原。要繼續嗎？",
    "inlayCompressDone": "壓縮完成",
    "inlayCompressCount": " 張圖片已壓縮",
    "saved": "已儲存",
    "notLoggedIn": "尚未登入 Risu 帳號",
    "SaveDataInAccount": "將資料儲存至帳號",
    "dataSavingInAccount": "正在將資料儲存至帳號",
    "logout": "登出",
    "loadDataFromAccount": "從帳號載入資料",
    "saveCurrentDataToAccount": "將目前資料儲存至帳號",
    "chatAssumed": "",
    "proxyAPIKey": "金鑰／密碼",
    "proxyRequestModel": "請求模型",
    "officialWiki": "官方 Wiki",
    "officialWikiDesc": "查看 PocketRisu 官方 Wiki",
    "officialDiscord": "官方 Discord",
    "officialDiscordDesc": "PocketRisu 官方 Discord 社群",
    "persona": "使用者人設",
    "personaSearch": "依名稱或備註搜尋",
    "personaManage": "管理使用者人設",
    "memoryPresetDefault": "預設套用的預設集",
    "memoryBindingLabel": "長期記憶綁定",
    "memoryPresetOff": "關閉",
    "memoryPresetInherit": "預設",
    "memoryPresetSetDefault": "設為預設",
    "memoryPresetCreate": "新增預設集",
    "memoryPresetSearch": "依預設集名稱搜尋",
    "memoryPresetMethod": "方式",
    "memoryPresetName": "預設集名稱",
    "memoryPresetManage": "管理長期記憶",
    "memoryPresetLastOne": "至少需要保留一個預設集",
    "memoryPresetBound": "已變更長期記憶預設集",
    "folderUncategorized": "未分類",
    "folderNew": "新增資料夾",
    "folderMoveTo": "移至資料夾",
    "folderDeleteKeepItems": "要刪除此資料夾嗎？其中的項目會移至「未分類」",
    "moveUp": "上移",
    "moveDown": "下移",
    "icon": "圖示",
    "account": "帳號",
    "remove": "移除",
    "able": "啟用",
    "assetWidth": "資源圖片最大寬度",
    "animationSpeed": "動畫速度",
    "screenshot": "螢幕截圖",
    "screenshotSaved": "螢幕截圖已儲存",
    "createBotwithAI": "使用 AI 建立角色",
    "changeFolderName": "輸入新的資料夾名稱（留空則取消）",
    "cancel": "取消",
    "renameFolder": "重新命名資料夾",
    "changeFolderColor": "變更資料夾顏色",
    "changeFolderImage": "變更資料夾圖片",
    "fullWordMatching": "完整單字比對",
    "botSettingAtStart": "啟動時開啟 Bot 設定",
    "triggerStart": "送出對話時",
    "triggerInput": "使用者送出訊息時",
    "triggerOutput": "角色回應時",
    "triggerManual": "僅手動觸發",
    "triggerCondVar": "若變數符合",
    "triggerCondExists": "若對話中存在文字",
    "triggerScript": "Trigger 腳本",
    "triggerMatchRegex": "使用 Regex 比對",
    "triggerMatchLoose": "寬鬆比對",
    "triggerMatchStrict": "嚴格比對",
    "searchDepth": "搜尋深度",
    "equal": "等於",
    "notEqual": "不等於",
    "greater": "大於",
    "less": "小於",
    "greaterEqual": "大於等於",
    "lessEqual": "小於等於",
    "triggerEffSysPrompt": "加入系統提示詞",
    "triggerEffSetVar": "修改變數",
    "triggerEffImperson": "送出對話",
    "triggerEffCommand": "執行指令",
    "triggerEffRunTrigger": "執行 Trigger",
    "triggerEffStop": "停止送出提示詞",
    "triggerEffCall": "呼叫 Trigger",
    "varableName": "變數名稱",
    "role": "身分",
    "location": "位置",
    "promptstart": "提示詞開頭",
    "promptend": "提示詞結尾",
    "historyend": "歷史紀錄結尾",
    "always": "一律",
    "noEffect": "無作用",
    "invaildTriggerEffect": "此效果不適用於目前的 Trigger 類型",
    "operator": "運算子",
    "TriggerSetToVar": "設定變數",
    "TriggerAddToVar": "變數加上",
    "TriggerSubToVar": "變數減去",
    "TriggerMulToVar": "變數乘以",
    "TriggerDivToVar": "變數除以",
    "isNull": "未設定",
    "ifChatIndex": "對話索引",
    "ifRandom": "隨機值",
    "ifValue": "指定值",
    "hideRealm": "預設收合 RisuRealm",
    "blockRealmCreator": "封鎖創作者",
    "blockRealmCreatorConfirm": "要封鎖 {{creator}} 在 RisuRealm 上的所有內容嗎？",
    "realmCreatorBlocked": "此內容來自已封鎖的 RisuRealm 創作者，無法使用。",
    "realmCreatorBlockedSuccess": "已封鎖創作者。",
    "manageBlockedRealmCreators": "管理已封鎖的創作者",
    "blockedRealmCreators": "已封鎖的 RisuRealm 創作者",
    "noBlockedRealmCreators": "沒有已封鎖的 RisuRealm 創作者。",
    "unblockRealmCreator": "解除封鎖",
    "hideAllImages": "隱藏所有圖片",
    "popularityLevel": "{} 人氣",
    "colorScheme": "配色方案",
    "colorSchemeDefault": "預設",
    "showLegacyColorSchemes": "顯示舊版調色盤",
    "rangeStart": "範圍開始",
    "rangeEnd": "範圍結束",
    "untilChatEnd": "直到對話結束",
    "usePromptTemplate": "使用提示詞模板",
    "specialType": "特殊類型",
    "noSpecialType": "無特殊類型",
    "forceProxyAsOpenAI": "強制代理使用 OpenAI 格式",
    "promptTemplate": "提示詞模板",
    "customInnerFormat": "自訂內部格式",
    "innerFormat": "內部格式",
    "HypaMemory": "HypaMemory",
    "ToggleHypaMemory": "切換 HypaMemory",
    "resetPromptTemplateConfirm": "確定要重設提示詞模板嗎？",
    "emotionMethod": "情緒處理方式",
    "continueResponse": "繼續回應",
    "showMenuChatList": "在選單顯示對話清單",
    "translatorLanguage": "翻譯語言",
    "translatorType": "翻譯器類型",
    "htmlTranslation": "HTML 翻譯",
    "deeplKey": "DeepL API 金鑰",
    "deeplFreeKey": "DeepL Free API 金鑰",
    "deeplXUrl": "DeepLX URL",
    "deeplXToken": "DeepLX Token",
    "exportPersona": "匯出使用者人設",
    "importPersona": "匯入使用者人設",
    "export": "匯出",
    "import": "匯入",
    "useNamePrefix": "使用名稱前綴",
    "textAdventureNAI": "以文字冒險模式執行",
    "appendNameNAI": "在 NAI 中附加名稱",
    "customStopWords": "自訂停止詞",
    "defaultPrompt": "預設提示詞",
    "additionalText": "額外描述",
    "seed": "Seed",
    "charjs": "CharacterJS",
    "depthPrompt": "深度插入提示詞",
    "largePortrait": "直式大圖",
    "reverseProxyOobaMode": "Ooba 模式",
    "exactTokens": "精確 Token 數",
    "fixedTokens": "估算 Token 數",
    "inlayViewScreen": "內嵌畫面",
    "imgGenPrompt": "圖片生成提示詞",
    "imgGenNegatives": "圖片生成負面提示詞",
    "imgGenInstructions": "圖片生成指示",
    "usePlainFetchWarn": "使用 NovelAI 時請停用此選項，否則可能發生 CORS 錯誤",
    "translationPrompt": "翻譯提示詞",
    "translationResponseSize": "翻譯回應長度",
    "webdeeplwarn": "不建議在網頁版使用此選項，可能造成 CORS 錯誤",
    "saveBackupLocal": "在本機儲存備份",
    "saveBackupForUpstream": "建立供原版 Risuai 使用的備份",
    "saveBackupForUpstreamConfirm": "此備份是用於將資料移轉至原版 Risuai（網頁版／Tauri）。由於內嵌圖片的項目名稱使用原版 Risuai 無法匯入的命名方式，因此不會包含內嵌圖片。其他資料（資料庫、角色資源、冷儲存）都會包含。\n\n若要在不同 PocketRisu 安裝之間移轉資料，請改用一般本機備份。\n\n要繼續嗎？",
    "loadBackupLocal": "從本機載入備份",
    "topP": "Top P",
    "genTimes": "一次生成的回應數",
    "cot": "Chain of Thought",
    "forcePlainFetch": "強制一般 Fetch",
    "autoFillRequestURL": "自動填入請求 URL",
    "newOAIHandle": "新版 OpenAI 處理方式",
    "inlayImage": "內嵌圖片功能",
    "nativeAutomark": "實驗性原生 Automark",
    "assistantPrefill": "assistant 預填",
    "postEndInnerFormat": "尾端附加提示詞",
    "sendChatAsSystem": "以 system 身分送出對話",
    "sendName": "在非群組對話中送出名稱",
    "utilOverride": "工具模式模板覆寫",
    "template": "模板",
    "chatAsOriginalOnSystem": "以原始身分送出",
    "exportAsDataset": "將存檔匯出為資料集",
    "editTranslationDisplay": "編輯翻譯顯示",
    "selectModel": "選擇模型",
    "autoRemoveThoughtTag": "移除 Thought Tag",
    "customChainOfThought": "自訂 Chain of Thought",
    "maxThoughtTagDepth": "Thought Tag 最大深度",
    "openRouterFallback": "使用備援模型",
    "openRouterMiddleOut": "使用 Middle Out",
    "openRouterProviderOrder": "供應商偏好順序",
    "openRouterProviderOnly": "允許的供應商",
    "openRouterProviderIgnore": "忽略的供應商",
    "openRouterSearchModel": "搜尋模型...",
    "openRouterSortByName": "名稱",
    "openRouterSortByPrice": "價格",
    "openRouterSortByProvider": "供應商",
    "openRouterSortAsc": "升冪",
    "openRouterSortDesc": "降冪",
    "geminiApiKey": "Gemini API 金鑰",
    "memoryLimitThickness": "記憶上限線條粗細",
    "inputCardPassword": "輸入角色卡密碼",
    "ccv2Desc": "Character Card V2 是聊天機器人程式廣泛使用的格式",
    "ccv3Desc": "Character Card V3 是聊天機器人程式使用的次世代格式",
    "rccDesc": "Risu Refined Character Card 是加入密碼、完整性檢查等額外功能的格式",
    "password": "密碼",
    "license": "授權條款",
    "licenseDesc": "可為卡片指定授權條款，限制下載者修改卡片或重新匯出的權限",
    "passwordDesc": "可設定密碼，避免未經授權存取您的角色卡",
    "largePersonaPortrait": "使用者人設大圖",
    "module": "模組",
    "modules": "模組",
    "noModules": "尚未安裝任何模組",
    "createModule": "建立模組",
    "basicInfo": "基本資訊",
    "moduleContent": "模組內容",
    "confirmRemoveModuleFeature": "確定要移除此功能嗎？此操作無法復原",
    "editModule": "編輯模組",
    "importModule": "匯入模組",
    "download": "下載",
    "edit": "編輯",
    "enableGlobal": "全域啟用",
    "chatModulesInfo": "可為目前對話或目前角色啟用／停用模組。對話泡泡按鈕代表目前對話範圍，人物按鈕代表目前角色範圍；帶有地球圖示的模組已全域啟用，會套用至所有對話，可至「設定 → 模組」變更",
    "moduleScopeChat": "套用至此對話",
    "moduleScopeCharacter": "套用至此角色",
    "moduleScopeGlobal": "已全域啟用。請至「設定 > 模組」變更",
    "sideMenuRerollButton": "側邊選單重新生成按鈕",
    "persistentStorage": "持久性儲存",
    "persistentStorageSuccess": "已成功啟用持久性儲存",
    "persistentStorageFail": "無法啟用持久性儲存。可能是您拒絕了權限請求，或瀏覽器不支援此功能",
    "persistentStorageRecommended": "建議啟用持久性儲存",
    "unsupportedFileType": "不支援的檔案類型",
    "persistentStorageDesc": "您的瀏覽器支援持久性儲存。建議啟用以獲得較佳效能與使用體驗",
    "enable": "啟用",
    "postFile": "附加檔案",
    "requestInfoInsideChat": "在對話中顯示請求資訊",
    "inputTokens": "輸入 Token",
    "outputTokens": "輸出 Token",
    "tokenWarning": "Token 計算可能不準確，建議僅作為參考",
    "log": "記錄",
    "popularityLevelDesc": "人氣值會依下載次數等因素增加",
    "additionalParams": "額外參數",
    "additionalParamsHelp": "每行一組。支援 `key=value`、`key=json::{...}`、`header::Name=value`、`key={{none}}`",
    "tokenizerOverride": "Tokenizer 覆寫",
    "tokenizerOverrideHelp": "用於 Token 計算。維持「自動」即可使用模型設定檔建議的 Tokenizer",
    "tokenizerAuto": "自動",
    "heightMode": "高度模式",
    "useAdvancedEditor": "使用進階編輯器",
    "noWaitForTranslate": "不等待翻譯完成",
    "antiClaudeOverload": "防止 Claude 過載",
    "activeTabChange": "其他分頁目前處於啟用狀態，因此此分頁已停用。若要切換至此分頁，請按「確定」",
    "sessionHandoffReload": "因另一台裝置正在使用，已重新載入為最新狀態",
    "addCharacter": "加入角色",
    "importFromRealm": "從 RisuRealm 選擇",
    "importFromRealmDesc": "可從 RisuRealm 的 1,000 多個角色中選擇",
    "random": "隨機",
    "metaData": "中繼資料",
    "autoContinueMinTokens": "最低 Token 數（自動繼續）",
    "autoContinueChat": "防止回應未完成（自動繼續）",
    "removeIncompleteResponse": "移除未完成句子",
    "tokenizer": "Tokenizer",
    "chatFormating": "對話格式",
    "useInstructPrompt": "使用 Instruct 格式",
    "textAreaSize": "編輯文字框高度",
    "textAreaTextSize": "編輯文字框文字大小",
    "sideBarSize": "側邊欄寬度",
    "embedding": "Embedding",
    "syntax": "語法",
    "run": "執行",
    "noMessage": "輸入訊息以開始對話",
    "combineTranslation": "合併後翻譯",
    "dynamicAssets": "動態資源",
    "dynamicAssetsEditDisplay": "在顯示階段使用動態資源",
    "longTermMemory": "長期記憶",
    "grid": "網格",
    "list": "清單",
    "trash": "垃圾桶",
    "trashDesc":
        "垃圾桶中的角色會以停用狀態保留在伺服器上，因此不會增加執行時負擔。系統不會自動刪除；您可隨時還原或永久刪除",
    "shareExport": "分享／匯出",
    "risupresetDesc": "Risupreset 是專為 PocketRisu 預設集設計的格式",
    "risuMDesc": "RisuM 是專為 PocketRisu 模組設計的格式",
    "jsonDesc": "JSON 是人類與機器都容易閱讀與撰寫的格式",
    "nickname": "暱稱",
    "useRegexLorebook": "使用 Regex",
    "customPromptTemplateToggle": "自訂開關",
    "defaultVariables": "預設變數",
    "lowLevelAccess": "低階存取",
    "resultStoredVar": "儲存結果的變數",
    "triggerEffRunLLM": "執行主要模型",
    "triggerEffectSendAI": "重新送出 AI 請求",
    "triggerEffCheckSim": "檢查相似度",
    "triggerEffShowAlert": "顯示提示",
    "normal": "一般",
    "error": "錯誤",
    "input": "輸入",
    "select": "選擇",
    "options": "選項",
    "alertContent": "提示內容",
    "lowLevelAccessConfirm":
        "此內容使用低階存取，代表它能直接存取 AI 模型與您的儲存空間。確定要匯入此內容嗎？",
    "triggerLowLevelOnly": "此 Trigger 只能在啟用低階存取時使用。請在角色或模組的進階設定中啟用低階存取",
    "truthy": "Truthy",
    "extractRegex": "使用 Regex 擷取文字",
    "runImgGen": "執行圖片生成",
    "cutChat": "截斷對話",
    "modifyChat": "修改對話",
    "regex": "Regex",
    "flags": "旗標",
    "resultFormat": "結果格式",
    "negPrompt": "負面提示詞",
    "start": "開始",
    "end": "結束",
    "index": "索引",
    "search": "搜尋",
    "goCharacterOnImport": "從 RisuRealm 匯入後開啟角色",
    "format": "格式",
    "v2Warning": "警告：已不再支援 V2 角色卡，資料可能不完整",
    "applyModule": "套用模組",
    "successApplyModule": "已成功套用模組",
    "font": "字型",
    "lineHeight": "行高",
    "loadAutoServerBackup": "載入伺服器自動備份",
    "notCharxWarn": "此角色使用多個資源。為了獲得較佳相容性，建議以 CharX 格式匯出",
    "noPlugins": "尚未安裝外掛",
    "legacyTranslation": "舊版翻譯",
    "clipboardSuccess": "已複製至剪貼簿",
    "translateContent": "翻譯內容",
    "doNotTranslate": "不要翻譯",
    "includePersonaName": "包含使用者人設名稱",
    "hidePersonaName": "隱藏使用者人設名稱",
    "triggerSwitchWarn": "變更 Trigger 類型後，目前的 Trigger 設定會遺失。確定要繼續嗎？",
    "codeMode": "程式碼",
    "blockMode": "區塊",
    "helpBlock": "說明",
    "hideChatIcon": "隱藏圖示 UI",
    "loadInternalBackup": "載入內部備份",
    "createCopy": "建立副本",
    "copyChatConfirm": "要建立此對話的副本嗎：",
    "copyChatSuccess": "已複製對話",
    "bindPersona": "綁定使用者人設",
    "chatOptions": "對話選項",
    "doYouWantToBindCurrentPersona": "要將目前的使用者人設綁定至此對話嗎？",
    "doYouWantToUnbindCurrentPersona": "要解除此對話綁定的使用者人設嗎？",
    "personaBindingLabel": "使用者人設綁定",
    "personaBindedSuccess": "已成功綁定使用者人設",
    "personaUnbindedSuccess": "已成功解除使用者人設綁定",
    "personaBindChange": "變更使用者人設",
    "personaBindUnbind": "解除綁定",
    "personaBindCurrent": "綁定目前的使用者人設",
    "personaSelectOther": "選擇其他使用者人設",
    "promptBindingLabel": "提示詞綁定",
    "promptPresetParamsUse": "使用提示詞參數",
    "promptPresetParamScopeDesc": "這些參數會儲存在此提示詞預設集中。在舊版模型模式下會一律套用；使用模型預設集時，只有在側邊欄「提示詞綁定」中啟用「使用提示詞參數」的對話才會套用取樣參數。容量設定（最大上下文／回應長度）屬於模型本身，因此一律由模型預設集決定",
    "promptBindedSuccess": "已成功綁定提示詞預設集",
    "promptUnbindedSuccess": "已成功解除提示詞預設集綁定",
    "promptBindChange": "變更提示詞預設集",
    "promptBindUnbind": "解除綁定",
    "promptBindCurrent": "綁定目前的提示詞預設集",
    "presetSelectOther": "選擇其他提示詞預設集",
    "promptPresets": "提示詞預設集",
    "presetEdit": "編輯",
    "modelPresets": "模型預設集",
    "modelPresetEmpty": "尚未建立模型預設集",
    "modelPresetCreate": "建立新的模型預設集",
    "basicSettings": "基本設定",
    "backToList": "回到清單",
    "selectProfile": "選擇模型設定檔",
    "searchProfiles": "搜尋模型設定檔",
    "noProfileMatch": "找不到符合的模型設定檔",
    "modelPresetCreated": "已建立模型預設集",
    "profileStatusCurrent": "現行",
    "profileStatusOutdated": "舊版",
    "profileStatusDeprecated": "已棄用",
    "profileTabOfficial": "官方",
    "profileTabCustom": "自訂",
    "profileImport": "匯入模型設定檔",
    "profileExport": "匯出",
    "profileDelete": "刪除",
    "profileExportNoBase": "無法匯出：找不到基礎供應商",
    "profileImportParseError": "無法解析 JSON",
    "profileImportInvalid": "無效的模型設定檔片段：",
    "profileOverwriteConfirm": "已有相同 ID 的自訂模型設定檔。要覆寫嗎？",
    "profileImported": "已匯入模型設定檔",
    "customProfileEmpty": "目前沒有自訂模型設定檔。匯入設定檔即可新增",
    "profileReplace": "取代模型設定檔",
    "profileReplaced": "已取代模型設定檔",
    "profileDataIncomplete": "此模型設定檔的資料不完整。請重新開啟「模型預設集」選單以重新整理模型目錄，然後再試一次",
    "profileUpdateAvailable": "有更新可用",
    "profileSourceMissing": "找不到來源模型設定檔",
    "profileSectionTitle": "模型設定檔",
    "profileUpdatedAtLabel": "目前版本",
    "profileLatestVersionLabel": "最新版本",
    "profileUpdateConfirm": "要更新至此模型設定檔嗎？",
    "profileReplaceWarn": "此模型設定檔未定義的設定將會遺失。要繼續嗎？",
    "profileUpdateLossWarn": "部分設定可能會遺失。要繼續嗎？",
    "registryNoticeBanner": "已更新 {n} 個模型設定檔",
    "registryNoticeMore": "詳細資訊",
    "registryNoticeTitle": "模型設定檔更新",
    "registryNoticeNewSection": "新增模型",
    "registryNoticeUpdatedSection": "已更新模型",
    "registryNoticeDismiss": "不再顯示此次更新",
    "registryNoticeConfirm": "確定",
    "apiKeyManagerMenu": "管理 API 金鑰",
    "apiKeyManagerDesc": "儲存 API 金鑰，以便在多個預設集中重複使用",
    "apiKeyAdd": "新增金鑰",
    "apiKeyName": "名稱",
    "apiKeyProvider": "供應商",
    "apiKeyProviderUnset": "未指定",
    "apiKeyValue": "API 金鑰",
    "apiKeyPoolEmpty": "尚未儲存任何金鑰",
    "apiKeyModePool": "已儲存金鑰",
    "apiKeyModeDirect": "直接輸入",
    "apiKeySelectNone": "未選取",
    "apiKeyDeletedOption": "已刪除的金鑰",
    "apiKeyShowAll": "顯示所有金鑰",
    "apiKeySave": "儲存此金鑰",
    "apiKeyFormSave": "儲存",
    "apiKeyNamePrompt": "輸入此金鑰的名稱",
    "parameters": "參數",
    "sizeAndSpeed": "大小與速度",
    "useLegacyGUI": "使用舊版 GUI",
    "claudeCachingExperimental": "Claude 快取",
    "openClose": "開啟／關閉",
    "hideApiKeys": "隱藏 API 金鑰",
    "unformatQuotes": "停用引號格式化",
    "enableDevTools": "啟用開發者工具",
    "selectFile": "選擇檔案",
    "namespace": "Namespace",
    "moduleIntergration": "模組整合",
    "previewInfo": "此預覽顯示套用模型專屬處理前的提示詞",
    "miscTools": "其他工具",
    "promptConvertion": "提示詞轉換",
    "convertionStep1": "選擇所有與提示詞相關的檔案（支援 Context、Instruct 與 Sampler JSON）",
    "customCSS": "自訂 CSS",
    "betaMobileGUI": "Beta 行動版 GUI（不建議使用）",
    "enableScrollToActiveChar": "啟用捲動至目前角色",
    "menu": "選單",
    "jsonSchema": "JSON Schema",
    "enableJsonSchema": "啟用 Schema",
    "strictJsonSchema": "嚴格 Schema",
    "extractJson": "擷取 JSON",
    "reloadSession": "發現較新版本的存檔資料，正在重新載入工作階段...",
    "fixMarkdownNewline": "修正 Markdown 換行",
    "customQuotes": "自訂引號",
    "leadingSingleQuote": "開頭單引號",
    "leadingDoubleQuote": "開頭雙引號",
    "trailingSingleQuote": "結尾單引號",
    "trailingDoubleQuote": "結尾雙引號",
    "translatorNote": "翻譯備註",
    "formatGroupInSingle": "非群組對話也顯示角色名稱",
    "groupInnerFormat": "非發言角色的內部格式",
    "chatHTML": "對話 HTML",
    "logShare": "顯示分享記錄按鈕",
    "preview": "預覽",
    "recommended": "推薦",
    "newChat": "新對話",
    "predictedOutput": "預測輸出",
    "systemContentReplacement": "system 內容替代格式",
    "systemRoleReplacement": "system 身分替代值",
    "seperateParameters": "獨立參數設定",
    "seperateParametersEnabled": "啟用獨立參數設定",
    "summarizationPrompt": "摘要提示詞",
    "reSummarizationPrompt": "重新摘要提示詞",
    "translatorPrompt": "翻譯提示詞",
    "translateBeforeHTMLFormatting": "在 HTML 格式化前翻譯",
    "retranslate": "重新翻譯",
    "editTranslation": "編輯翻譯",
    "editTranslationSave": "儲存翻譯",
    "exportTranslationCache": "匯出翻譯快取",
    "exportTranslationCacheSuccess": "已成功匯出翻譯快取",
    "importTranslationCache": "匯入翻譯快取",
    "importTranslationCacheConfirm": "這會將項目合併至您的翻譯快取，現有同名鍵會被覆寫。確定要繼續嗎？",
    "importTranslationCacheSuccess": "已匯入 {0} 筆翻譯快取",
    "importTranslationCacheFailed": "已匯入 {0} 筆，但有 {1} 筆無法儲存。儲存空間可能已滿",
    "exportTranslationCacheEmpty": "目前沒有翻譯快取",
    "clearTranslationCache": "清除翻譯快取",
    "clearTranslationCacheSuccess": "已成功清除翻譯快取",
    "clearTranslationCacheConfirm": "這會刪除所有翻譯快取項目，且無法復原。確定要繼續嗎？",
    "loading": "載入中",
    "autoTranslateCachedOnly": "只自動翻譯已有翻譯快取的訊息",
    "notification": "通知",
    "permissionDenied": "瀏覽器或作業系統拒絕權限",
    "customFlags": "自訂旗標",
    "enableCustomFlags": "啟用自訂旗標",
    "googleCloudTokenization": "Google Cloud Tokenization",
    "presetChain": "預設集隨機切換",
    "legacyMediaFindings": "舊版媒體搜尋",
    "staticsDisclaimer": "統計資料僅基於 2024 年 7 月之後的資料，可能不完全準確",
    "subtitles": "字幕",
    "subtitlesWarning1": "使用此功能時，模型必須支援音訊／影片輸入",
    "subtitlesWarning2": "使用此功能時，模型必須支援串流",
    "reset": "重設",
    "clearInputConfirm": "要清除此欄位中的所有文字嗎？",
    "assetMaxDifference": "資源比對最大距離",
    "sourceLanguage": "原文語言",
    "destinationLanguage": "目標語言",
    "noWebGPU": "您的瀏覽器或作業系統不支援 WebGPU，效能會明顯下降",
    "menuSideBar": "側邊選單（不建議使用）",
    "home": "首頁",
    "showSavingIcon": "顯示儲存中圖示",
    "pluginVersionWarn":
        "此外掛版本為 {{plugin_version}}，與目前 PocketRisu 版本不相容。請將外掛更新至 {{required_version}}",
    "imageTranslation": "圖片翻譯",
    "banCharacterset": "出現指定字元集時自動重新生成",
    "realmDirectOpen": "在 RisuRealm 預覽中直接開啟角色描述",
    "showPromptComparison": "顯示提示詞比較",
    "inlayErrorResponse": "內嵌錯誤回應",
    "triggerOn": "Trigger 時機",
    "noConfig": "無設定",
    "varName": "變數名稱",
    "var": "變數",
    "condition": "條件",
    "trigger": "Trigger",
    "outputVar": "輸出變數",
    "source": "來源",
    "cmd": "指令",
    "sysStart": "系統開始",
    "sysHistoryEnd": "系統歷史結束",
    "sysPromptEnd": "系統提示詞結束",
    "target": "目標",
    "addElse": "加入 Else",
    "min": "最小值",
    "max": "最大值",
    "delimiter": "分隔符號",
    "deleteCount": "刪除數量",
    "triggerEffRunAxLLM": "執行輔助模型",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 是同時使用摘要與向量搜尋的長期記憶系統",
        "supaMemoryPromptPlaceHolder": "留空以使用預設值",
        "maxMemoryTokensRatioLabel": "最大記憶 Token 比例（估算）",
        "maxMemoryTokensRatioError": "無法計算最大記憶 Token 比例",
        "memoryTokensRatioLabel": "記憶 Token 比例",
        "extraSummarizationRatioLabel": "額外摘要比例",
        "maxChatsPerSummaryLabel": "每份摘要最大訊息數",
        "queryChatCountLabel": "相似度查詢使用的近期訊息數",
        "summaryChunkSeparatorLabel": "摘要區塊分隔用 Regex",
        "recentMemoryRatioLabel": "近期記憶比例",
        "similarMemoryRatioLabel": "相似記憶比例",
        "randomMemoryRatioLabel": "隨機記憶比例",
        "enableSimilarityCorrectionLabel": "啟用相似度修正",
        "preserveOrphanedMemoryLabel": "保留原始訊息已被刪除的摘要",
        "applyRegexScriptWhenRerollingLabel": "重新生成時套用 Regex 腳本",
        "doNotSummarizeUserMessageLabel": "不摘要使用者訊息",
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3",
        "resetConfirmMessage": "此操作無法復原。要重設 HypaV3 資料嗎？",
        "resetConfirmSecondMessage": "此操作無法復原。再次確認：確定要重設 HypaV3 資料嗎？",
        "convertLabel": "目前還沒有摘要，但可以將 HypaV2 資料轉換成 V3",
        "convertButton": "轉換為 V3",
        "convertSuccessMessage": "已成功將 HypaV2 資料轉換成 V3",
        "convertErrorMessage": "無法將 HypaV2 資料轉換成 V3：{0}",
        "noSummariesLabel": "目前沒有摘要",
        "searchPlaceholder": "輸入 #N、ID 或搜尋內容",
        "summaryNumberLabel": "摘要 #{0}",
        "deleteThisConfirmMessage": "要刪除此摘要嗎？",
        "deleteAfterConfirmMessage": "要刪除此摘要之後的所有摘要嗎？",
        "deleteAfterConfirmSecondMessage": "此操作無法復原。真的確定嗎？",
        "translationLabel": "翻譯",
        "rerolledSummaryLabel": "重新生成的摘要",
        "rerolledTranslationLabel": "重新生成摘要的翻譯",
        "connectedMessageCountLabel": "已連結訊息（{0}）",
        "connectedFirstMessageLabel": "第一則訊息",
        "connectedMessageRoleLabel": "{0} 的訊息",
        "connectedMessageNotFoundLabel": "找不到訊息",
        "connectedMessageLoadingError": "載入已連結訊息時發生錯誤：{0}",
        "connectedMessageTranslationLabel": "翻譯",
        "nextSummarizationFirstMessageLabel": "第一則訊息",
        "nextSummarizationNoMessageIdLabel": "沒有訊息 ID",
        "nextSummarizationLabel": "HypaV3 接下來會摘要 [{0}]",
        "nextSummarizationNoMessagesFoundLabel": "警告：找不到訊息",
        "nextSummarizationLoadingError": "載入下一個摘要目標時發生錯誤：{0}",
        "summarizationConditionLabel": "提示：當輸入 Token 超過最大上下文長度時，HypaV3 會開始進行摘要",
        "emptySelectedFirstMessageLabel": "警告：選取的第一則訊息是空的",
        "unclassified": "未分類",
        "reSummarize": "重新摘要",
        "reSummarizing": "正在重新摘要...",
        "reSummarizeResult": "重新摘要結果",
        "retry": "重試",
        "translate": "翻譯",
        "tag": "標籤",
        "tagManager": "標籤管理",
        "tagManagerTitle": "標籤管理 - 摘要 #{0}",
        "newTagName": "新標籤名稱",
        "noTagsYet": "目前沒有標籤",
        "addNewTagHint": "在上方加入新標籤",
        "categoryManager": "分類",
        "allCategories": "全部",
        "categoryName": "分類名稱",
        "noCategoriesYet": "目前沒有分類",
        "addNewCategoryHint": "按下上方的 + 按鈕新增分類",
    },
    "bulkEnabling": "Lorebook 批次啟用",
    "showTranslationLoading": "顯示「翻譯中」提示",
    "showDeprecatedTriggerV1": "顯示已棄用的 Trigger V1",
    "showDeprecatedTriggerV2": "顯示已棄用的 Trigger V2",
    "triggerV1Warning": "Trigger V1 已棄用，未來可能會被移除",
    "copy": "複製",
    "paste": "貼上",
    "depth": "深度",
    "returnCSSError": "回傳 CSS 錯誤",
    "alwaysActiveInChat": "一律啟用（目前對話）",
    "childLoreDesc": "這是角色 Lorebook 條目的副本，會維持「一律啟用」，直到此副本被移除，或原始條目被手動停用",
    "thinkingTokens": "思考 Token",
    "thinkingType": "思考模式",
    "adaptiveThinkingEffort": "自動調整思考強度",
    "antiServerOverload": "防伺服器過載",
    "localActivationInGlobalLorebook": "允許全域 Lorebook 使用個別啟用條件",
    "cachePoint": "快取點",
    "all": "全部",
    "showFolderNameInIcon": "在圖示中顯示資料夾名稱",
    "claudeCachingRetrival": "延長 Claude 快取",
    "claudeCachingRetrivalDesc":
        "每 4 分鐘送出一次請求，以延長 Claude 快取的有效時間。這可降低快取未命中率，但若使用不當，也可能增加成本",
    "automaticCachePoint": "自動快取點",
    "experimentalChatCompression": "實驗性對話資料處理",
    "loadingChatData": "正在載入對話資料",
    "selectChatToView": "選擇要查看的對話",
    "outputImageModal": "輸出圖片視窗",
    "playMessageOnTranslateEnd": "翻譯完成後播放音訊",
    "soundAndNotification": "音效與通知",
    "groupBrowserNotification": "瀏覽器通知",
    "groupMessageNotification": "訊息完成通知",
    "groupTranslateNotification": "翻譯完成通知",
    "notificationEnable": "啟用",
    "soundEffect": "音效",
    "soundEffectVolume": "音量",
    "selectNotificationSound": "選擇通知音效",
    "uploadSound": "上傳自訂音效",
    "uploadedSound": "已上傳音效",
    "soundDefault": "預設",
    "descBrowserNotification": "回應完成時顯示瀏覽器通知",
    "descMessageSound": "回應完成時播放音效",
    "descTranslateSound": "翻譯完成時播放音效",
    "auxModelUnderModelSettings": "在模型設定中，顯示各輔助功能的使用模型",
    "showModelInSidebar": "在側邊欄顯示模型選擇",
    "showPresetInSidebar": "在側邊欄顯示預設集選擇",
    "showPersonaInSidebar": "在側邊欄顯示使用者人設綁定",
    "disableMobileDragDrop": "停用行動裝置上的角色拖放",
    "disableToggleBinding": "停用對話開關綁定",
    "seperateModelsForAxModels": "為各輔助功能分別設定模型",
    "axModelsDef": "Ax 模型定義",
    "doNotChangeSeperateModels": "切換預設集時，不要變更各輔助功能的模型",
    "useDefaultSubModel": "使用預設輔助模型",
    "modelPresetBindingMainUnset": "此對話尚未綁定主要模型預設集。請先綁定後再送出",
    "modelPresetBindingSubUnset": "此對話尚未綁定輔助模型預設集。請先綁定後再送出",
    "modelPresetBindingTitle": "模型／輔助模型預設集綁定",
    "modelBindingTitle": "模型綁定",
    "modelSlotLegacySection": "舊版模型",
    "modelSlotLegacyGlobal": "舊版 · 依全域設定",
    "modelSlotLegacyGlobalShort": "依全域設定",
    "modelSlotPresetSection": "模型預設集",
    "modelSlotLegacyBadge": "舊版",
    "modelSlotLegacyGlobalHint": "全域舊版模型（切換提示詞預設集時會跟著變更）：",
    "useModelPresetBindingToggle": "使用模型預設集綁定",
    "modelPresetConfigure": "設定模型預設集",
    "modelPresetSetDefaultConfirm": "要將目前的模型綁定設為新對話的預設值嗎？",
    "modelPresetBindedSuccess": "已成功綁定模型預設集",
    "maxContextCapInfo": "模型設定檔上限：{} Token。留空或填入更大的值時，都會限制在此上限",
    "maxContextCapExceeded": "您輸入的值超過模型設定檔上限，因此只會使用 {} Token。若要使用您輸入的數值，請啟用下方的「忽略模型上限」",
    "maxContextIgnoreCap": "忽略模型上限",
    "maxContextIgnoreCapHelp": "模型設定檔中的上下文上限不正確時可啟用。啟用後會直接使用上方輸入值；若超過服務的實際上限，供應商會回傳錯誤。上方留空時此選項不會生效",
    "streamingOverride": "串流回應",
    "streamingOverrideHelp": "設定此預設集是否以串流方式接收回應",
    "decoupledStreaming": "串流傳輸、完成後一次顯示",
    "decoupledStreamingHelp": "請求仍使用串流連線傳送，但會等回應完成後一次顯示全文。可避開部分供應商對非串流回應的輸出上限與逾時，也能避免逐 Token 更新畫面的成本",
    "modelPresetToolUse": "工具使用",
    "modelPresetToolUseHelp": "允許此預設集呼叫已設定的工具（MCP）。預設關閉。執行工具時會以非串流方式送出請求",
    "modelPresetAbilities": "模型能力",
    "modelPresetPickSuggestion": "從建議中選擇…",
    "modelPresetSnapshotEmpty": "此預設集的模型設定檔資料為空。請重新下載或取代設定檔以還原設定",
    "modelPresetImageInput": "圖片輸入",
    "modelPresetImageInputHelp": "將圖片傳送給模型。預設關閉；只有模型確實支援圖片輸入時才應啟用（例如 Ollama gemma3、llava）",
    "modelPresetFoldSystem": "將 system 訊息轉為 user 訊息",
    "modelPresetFoldSystemHelp": "送出前將 system 訊息轉換為 user 訊息。預設關閉；適用於原生不支援 system 身分的模型（例如 Ollama gemma3）",
    "modelPresetKeepFirstSystem": "保留第一則 system 訊息",
    "modelPresetKeepFirstSystemHelp": "轉換 system 訊息時，保留最前面的 system 訊息不轉換。適用於允許最前方保留一則 system 訊息的模型",
    "modelPresetAlternateRole": "強制身分交替",
    "modelPresetAlternateRoleHelp": "將連續且身分相同的訊息合併為一則。預設關閉；適用於要求 user／assistant 必須交替出現的模型（例如 gemma）",
    "modelPresetStartWithUser": "以 user 訊息開始",
    "modelPresetStartWithUserHelp": "若對話不是以 user 訊息開始，會在最前方加入一則空白 user 訊息。預設關閉；適用於不接受第一則訊息為非 user 身分的模型",
    "modelPresetCacheSection": "上下文快取",
    "modelPresetCacheEnable": "使用上下文快取",
    "modelPresetCacheEnableHelp": "將重複的提示詞前綴快取在 Google 伺服器，以降低輸入 Token 成本。快取邊界由提示詞模板中的快取點卡片（或「自動快取點」）決定",
    "modelPresetCachePluginWarning": "若同時搭配外部快取外掛使用會互相衝突，導致快取無法正常運作。兩者只能擇一使用",
    "modelPresetCacheTtl": "快取保留時間（秒）",
    "modelPresetCacheTtlHelp": "伺服器保留快取的時間。時間越長，越能涵蓋回合之間的思考時間，但在整段保留期間都會產生儲存費用",
    "modelPresetCacheExtend": "命中時延長保留時間",
    "modelPresetCacheExtendHelp": "每次請求命中快取時，都會重新延長快取有效期限",
    "modelPresetCacheAdvanced": "進階",
    "modelPresetCacheMinTokens": "提示詞最低 Token 數",
    "modelPresetCacheMinTokensHelp": "提示詞低於此 Token 數時不建立快取",
    "modelPresetCacheGrowth": "提示詞增加指定 Token 數後重建",
    "modelPresetCacheGrowthHelp": "快取建立後，提示詞增加達到此 Token 數時重新建立快取",
    "maxContextHelp": "此預設集可用於輸入（提示詞）的 Token 預算。留空時使用預設值（65000），並受模型上下文長度上限限制。這不是回應長度；回應長度由 Max Tokens 控制",
    "modelPresetTabPresets": "預設集",
    "modelPresetTabOptions": "設定",
    "modelPresetTabTest": "測試",
    "modelPresetTabModules": "模組綁定",
    "moduleModelBindingEnable": "依模組分別綁定模型",
    "moduleModelBindingUnset": "未設定",
    "moduleModelBindingEmpty": "已安裝的模組中沒有會呼叫模型的模組",
    "moduleModelBindingDangling": "原先指定的預設集已不存在。請選擇其他預設集，或重新匯入原預設集以恢復綁定",
    "modelPresetTestTitle": "測試請求",
    "modelPresetTestHelp": "使用此預設集送出單一訊息，以確認驗證資訊與端點是否正常回應。測試內容不會儲存至任何對話",
    "modelPresetTestSend": "送出測試",
    "modelPresetTestSending": "傳送中…",
    "modelPresetTestSuccess": "成功",
    "modelPresetTestFail": "失敗",
    "modelPresetTestDefault": "我想洗車。洗車場離我 50 公尺，我應該走路還是開車過去？",
    "profileVisibilityLevel": "模型設定檔顯示範圍",
    "profileVisibilityAll": "顯示全部",
    "profileVisibilityHideDeprecated": "隱藏已棄用項目",
    "profileVisibilityCurrentOnly": "只顯示現行項目",
    "useCustomRegistry": "自訂模型目錄",
    "customRegistryUrl": "模型目錄 URL",
    "customRegistryWarning": "只使用您信任的模型目錄來源。惡意模型目錄可能將請求與您的 API 金鑰導向非預期的伺服器",
    "registryRefresh": "同步模型目錄",
    "registryRefreshHelp": "從目前的模型目錄來源重新下載模型設定檔清單",
    "registryRefreshNow": "立即重新整理",
    "registrySyncing": "同步中…",
    "registrySyncUpdated": "已更新至最新模型目錄",
    "registrySyncUpToDate": "模型目錄已是最新版本",
    "registryRefreshed": "已重新整理模型目錄",
    "registrySyncFailed": "模型目錄同步失敗",
    "modelPresetDeleted": "已刪除預設集",
    "modelPresetUnset": "未設定",
    "modelPresetSetAsDefault": "將目前綁定設為新對話的預設值",
    "modelPresetDefaultSaved": "已儲存為預設綁定",
    "modelPresetSaveAsDefaultButton": "設為預設",
    "modelModeLabel": "模型模式",
    "modelModeLegacy": "舊版模型",
    "modelModePreset": "模型預設集",
    "modelModeSettingsTitle": "開啟模型模式設定",
    "modelModeLockLabel": "模型模式設定",
    "modelModeLockLegacy": "固定使用舊版模型模式",
    "modelModeLockLegacyDesc": "使用原版 Risuai 的模型系統",
    "modelModeLockPreset": "固定使用模型預設集模式",
    "modelModeLockPresetDesc": "使用 PocketRisu 的模型預設集綁定系統",
    "modelModeLockNone": "不固定",
    "modelModeLockNoneDesc": "由每個對話自行選擇模式",
    "newChatModelModeLabel": "新對話的預設模型模式",
    "modelTabBuiltin": "內建",
    "modelTabPlugin": "外掛",
    "axModelMemory": "記憶",
    "axModelTranslate": "翻譯",
    "axModelEmotion": "情緒",
    "axModelOther": "其他",
    "tools": "Tools",
    "action": "操作",
    "hotkey": "快捷鍵",
    "hotkeyDesc": {
        "reroll": "重新生成",
        "unreroll": "復原重新生成",
        "translate": "翻譯",
        "remove": "移除",
        "edit": "編輯",
        "copy": "複製",
        "send": "送出",
        "settings": "設定",
        "home": "首頁",
        "presets": "快速選擇預設集",
        "persona": "快速選擇使用者人設",
        "modelSelect": "快速選擇模型",
        "toggleCSS": "切換 CSS",
        "prevChar": "上一個角色",
        "nextChar": "下一個角色",
        "quickMenu": "快速選單",
        "quickSettings": "快速設定",
        "toggleVoice": "切換語音",
        "toggleLog": "切換記錄",
        "previewRequest": "預覽請求",
        "import": "匯入",
        "export": "匯出",
        "webcam": "切換網路攝影機",
        "focusInput": "聚焦輸入框",
        "scrollToActiveChar": "捲動至目前角色",
        "popupEditor": "彈出式編輯器",
    },
    "screenTooSmall": "螢幕太小，無法顯示此介面",
    "advancedModelSettings": "進階模型設定",
    "fallbackModel": "備援模型",
    "fallbackWhenBlankResponse": "空白回應時使用備援模型",
    "doNotChangeFallbackModels": "切換預設集時不要變更備援模型",
    "customModels": "自訂模型",
    "igpPrompt": "IGP 提示詞",
    "useTokenizerCaching": "使用 Tokenizer 快取",
    "hypaMemoryV3Modal": "Hypa V3 視窗",
    "showMenuHypaMemoryModal": "在選單顯示 Hypa 視窗",
    "promptInfoInsideChat": "將提示詞資訊儲存至對話",
    "promptTextInfoInsideChat": "將提示詞文字儲存至對話",
    "promptInfoEmptyMessage": "此訊息沒有可用的提示詞資訊",
    "promptInfoEmptyToggle": "目前沒有啟用任何自訂開關",
    "promptInfoEmptyText": "尚未儲存提示詞文字",
    "escapeOutput": "跳脫輸出",
    "claudeBatching": "Claude 批次處理",
    "claude1HourCaching": "Claude 1 小時快取",
    "folderNameInput": "請輸入新的資料夾名稱",
    "folderRemoveLengthError": "要移除資料夾，資料夾內不能包含任何項目",
    "personaNotePlaceholder": "在此輸入用來區分此使用者人設的唯一識別。例如：「獵人人設」",
    "personaDuplicate": "建立副本",
    "mcpAccessPrompt": '{{tool}} 正嘗試執行「{{action}}」。要允許嗎？',
    "rememberToolUsage": "保留工具使用結果",
    "simplifiedToolUse": "簡化工具使用",
    "toolCalled": "已呼叫工具「{{tool}}」",
    "static": "靜態",
    "dynamic": "動態",
    "assetStyle": "資源樣式",
    "insertAssetPrompt": "插入資源提示詞",
    "requestLocation": "請求位置",
    "newImageHandlingBeta": "新版圖片處理（Beta）",
    "settingsExported": "Bug 回報用設定已匯出並複製至剪貼簿",
    "bookmarks": "書籤",
    "noBookmarks": "沒有書籤",
    "bookmarkAskNameOrDefault": "輸入書籤名稱。若留空，系統會自動命名",
    "bookmarkAskNameOrCancel": "輸入書籤名稱。若留空，將取消重新命名",
    "collapseAll": "全部收合",
    "expandAll": "全部展開",
    "hideErrorDetails": "隱藏錯誤詳細資訊",
    "showErrorDetails": "顯示錯誤詳細資訊",
    "dynamicOutput": "動態輸出",
    "autoAdjustSchema": "自動調整 Schema",
    "dynamicMessages": "動態訊息",
    "dynamicMemory": "動態記憶",
    "dynamicResponseTiming": "動態回應時機",
    "showTypingEffect": "顯示「正在輸入」指示",
    "dynamicRequest": "動態請求",
    "dynamicOutputPrompt": "動態輸出提示詞",
    "settingsCloseButtonSize": "設定視窗關閉按鈕大小",
    "translating": "翻譯中...",
    "stackTraceTranslationFailed": "堆疊追蹤翻譯失敗。以下顯示原始的混淆堆疊追蹤",
    "apply": "套用",
    "send": "送出",
    "add": "加入",
    "nightlyWarning":
        "## 測試版\n\n您目前使用的是測試版。此版本僅供測試，可能包含尚未修正的問題。**測試版不提供個別問題排除支援**",
    "loginSionyw": "使用 Sionyw 帳號登入",
    "pluginRiskDetectedAlert": "PocketRisu 偵測到可能有害的程式碼，**可能竊取您的 API 金鑰或個人資料**。強烈建議**不要安裝此外掛**",
    "doNotInstall": "不要安裝",
    "continueAnyway": "仍要繼續",
    "pluginNoRiskButAlert": "PocketRisu 未偵測到有害程式碼，但從不可信來源安裝外掛仍可能帶來安全風險",

    "pluginRisksInuserFriendly": {
        "eval": "從字串執行程式碼",
        "globalAccess": "存取全域變數",
        "thisOutsideClass": "在 class 範圍外使用 `this`",
        "errorInVerification": "驗證過程發生錯誤",
        "storageAccess": "存取儲存空間",
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "此外掛嘗試執行字串中的程式碼；字串可能經過混淆，用來隱藏惡意程式碼",
        "globalAccess": "此外掛嘗試存取全域變數，可能造成非預期副作用或安全漏洞",
        "thisOutsideClass": "此外掛在 class 範圍外使用 `this`，可能造成非預期行為或安全問題",
        "errorInVerification": "外掛驗證過程中發生錯誤，可能代表功能或安全性存在問題",
        "storageAccess": "此外掛嘗試存取儲存空間，可能導致資料外洩或未授權的資料修改",
    },
    "generatedByAIDisclaimer": "此內容由 AI 生成，可能包含不準確資訊或偏見",
    "aiGenerationWarning": "內容將由 AI 生成，可能包含不準確資訊或偏見",
    "duplicatePluginFoundUpdateIt": "已安裝相同外掛。要更新現有外掛嗎？",
    "pluginUpdateFoundInstallIt": "發現外掛更新。要安裝更新嗎？",
    "goToChat": "前往對話",
    "bookmark": "書籤",
    "translate": "翻譯",
    "branch": "分支",
    "branchedText": "此對話由 {} 分支而來",
    "loadMore": "載入更多",
    "disableMessage": "停用訊息",
    "disableFirstMessageConfirm": "要停用這則開局訊息嗎？停用後不會加入上下文",
    "disableAbove": "從此處截斷提供給 AI 的訊息",
    "autoScrollToNewMessage": "自動捲動至新訊息",
    "alwaysScrollToNewMessage": "永遠捲動至新訊息（忽略目前捲動位置）",
    "newMessage": "新訊息",
    "newMessageButtonStyle": "新訊息按鈕樣式",
    "newMessageButtonBottomCenter": "底部中央（預設）",
    "newMessageButtonBottomRight": "右下角",
    "newMessageButtonBottomLeft": "左下角",
    "newMessageButtonFloatingCircle": "浮動圓形按鈕（右下角）",
    "newMessageButtonRightCenter": "右側中央",
    "newMessageButtonTopBar": "頂端列",
    "trimStartNewChat": "略過「開始新對話」系統標記",
    "pluginDevelopMode": "外掛開發模式",
    "fetchLogConsent": "外掛 {} 正要求讀取記錄，其中可能包含敏感資訊。要允許嗎？", 
    "getFullDatabaseConsent": "外掛 {} 正要求存取完整資料庫，其中可能包含敏感資訊。要允許嗎？",
    "mainDomAccessConsent": "外掛 {} 正要求存取 PocketRisu 主介面的 DOM，其中可能包含敏感資訊。要允許嗎？",
    "replacerPermissionConsent": "外掛 {} 正要求替換對話內容的權限，這可能被用來操控對話。要允許嗎？",
    "providerPermissionConsent": "外掛 {} 正要求使用模型供應商功能，這可能讓它發出未經授權的 API 請求。要允許嗎？",
    "inlayPermissionConsent": "外掛 {} 正要求存取內嵌內容，這可能讓它讀取、寫入或編輯內嵌資料。要允許嗎？",
    "sendChatConsent": "外掛 {} 正要求以您的名義送出對話訊息，這會觸發 AI 回應。要允許嗎？",
    "pluginPermissionDenyGuide": "已拒絕外掛「{}」的權限要求。被拒絕的權限之後不會再次詢問。\n\n若您是不小心拒絕，可前往「設定 > 外掛」，在該外掛中使用「重設權限回應」復原",
    "pluginFullStorageAccess": "提供所有外掛資料（相容 Risuai）",
    "pluginFullStorageAccessDesc": "此外掛每次讀取資料庫時，都會收到所有外掛已儲存的資料。每次讀取都必須複製整個外掛儲存空間（目前 {}），因此只有確實需要其他外掛資料的外掛才應啟用",
    "pluginFullStorageAccessLarge": "外掛儲存空間已超過 100 MB。若為頻繁讀取資料的外掛啟用，可能導致應用程式變慢或無回應",
    "pluginFullStorageAccessGuide": "了解更多",
    "resetPluginPermission": "重設權限回應",
    "resetPluginPermissionConfirm": "要清除外掛「{}」所有已儲存的權限回應（允許／拒絕記錄）嗎？\n\n此外掛下次要求權限時會重新詢問",
    "resetPluginPermissionDone": "已重設「{}」的權限回應",
    "pluginV2Warning": "外掛 V2 與 V2.1 被視為不安全，並會在未來版本停止運作。**請勿使用這些版本的外掛。** 若您是此外掛的開發者，請儘快升級至 V3",
    "createFolderOnBranch": "建立分支時自動建立資料夾",
    "hamburgerButtonBottom": "將選單按鈕移至側邊欄底部",
    "hideLeftBarCollapseButton": "隱藏左側欄收合按鈕",
    "partialBackupFirstConfirm": "⚠️ 警告：部分本機備份 ⚠️\n\n此備份只會快速儲存必要資訊。\n\n會包含：\n- 資料庫（對話紀錄、角色、模組、外掛、提示詞、設定等）\n- 角色頭像（主要圖片）\n- 使用者頭像與自訂背景\n- 人設頭像\n- 資料夾圖片\n- 提示詞預設集圖片\n\n⚠️ 不會包含：\n- 情緒立繪\n- 額外角色資源\n- VITS 語音檔案\n- 其他所有額外媒體檔案\n\n此備份檔案**不包含所有角色資源**！\n若需要完整備份，請使用一般本機備份。\n\n確定要繼續嗎？",
    "partialBackupSecondConfirm": "⚠️⚠️ 最後警告 ⚠️⚠️\n\n此備份只會儲存必要資料與部分圖片，不會儲存大多數角色資源！\n\n會儲存：\n- 資料庫（對話紀錄、角色、模組、外掛、提示詞、設定等）\n- 角色頭像（主要圖片）\n- 使用者頭像與自訂背景\n- 人設頭像\n- 資料夾圖片\n- 提示詞預設集圖片\n\n不會儲存：\n- 情緒立繪\n- 額外角色資源\n- VITS 語音檔案\n- 其他所有媒體檔案\n\n⚠️ 只有在您**不需要**備份檔中的角色資源時才應繼續！⚠️\n\n真的確定要進行部分備份嗎？",
    "savePartialLocalBackup": "儲存部分本機備份（不含角色資源）",
    "serverBackupHeader": "PocketRisu 伺服器備份",
    "serverBackupDesc": "不需下載，即可直接在安裝 PocketRisu 的裝置（伺服器）上儲存與還原備份檔案",
    "serverBackupSave": "將備份儲存至伺服器",
    "serverBackupManage": "管理伺服器備份",
    "serverBackupSaving": "正在將備份儲存至伺服器...",
    "pluginStorageV2PreloadFailed": "無法載入外掛儲存資料，因此未啟動 V2 外掛。請重新整理頁面後再試",
    "serverBackupSaveSuccess": (filename: string, size: string, dir?: string) => `已儲存備份：${filename}（${size}）${dir ? `，位置：${dir}` : ''}`,
    "serverBackupLoading": "正在載入備份清單...",
    "serverBackupEmpty": "找不到伺服器備份",
    "serverBackupRestore": "還原",
    "serverBackupDownload": "下載",
    "serverBackupDelete": "刪除",
    "serverBackupRestoring": "正在從伺服器還原備份...",
    "serverBackupDeleteConfirm": (filename: string) => `要刪除備份「${filename}」嗎？此操作無法復原`,
    "serverBackupDeleteSuccess": "已刪除備份",
    "pluginProviderNotFound": "偵測到未知外掛。請更換模型，或啟用對應的外掛",
    "bootstrap": {
        "dataCorruptionDetected": (name: string, type: string) => `偵測到資料損毀\n\n模組「${name}」的 Lorebook 格式已損毀。\n\n損毀資料類型：${type}`,
        "reportErrorQuestion": "要將此錯誤回報給開發者嗎？\n這有助於避免相同錯誤再次發生。\n（只包含已損毀模組的資訊，不包含個人資料）",
        "diagnosticInformation": (reportData: string) => `# 診斷資訊\n\n請複製下方資訊，透過 GitHub Issues、Discord 或社群回報給開發者。\n送出前請再次確認其中沒有敏感資訊。\n\n\`\`\`json\n${reportData}\n\`\`\``,
        "resetLorebookQuestion": "只重設此特定損毀模組中的 Lorebook 資料嗎？\n（其他模組與角色資料**不會**受到影響）\n\n選擇「否」會保留資料，但錯誤可能持續發生",
    },
    "partialEdit": {
        "editButtonTooltip": "編輯",
        "deleteButtonTooltip": "刪除",
        "deleteModalTitle": "確認刪除",
        "deleteConfirmMessage": "確定要刪除此部分嗎？",
        "deleteYes": "是",
        "deleteNo": "否",
        "editModalTitle": "局部編輯",
        "matchFound": (method: string) => `比對方式：${method}`,
        "matchFailedTitle": "無法局部編輯",
        "matchFailedMessage": "無法在原始訊息中精確找到這段內容。句子過長或內容重複時可能發生此情況，請改用完整訊息編輯",
        "selectMatch": "選擇要編輯的區塊",
        "selectDeleteMatch": "選擇要刪除的區塊",
        "matchesFound": "個相符結果",
        "lineNumber": (line: number) => `約第 ${line} 行`,
        "saveShortcut": "儲存（Ctrl+Enter）",
        "cancelShortcut": "取消（Esc）",
        "save": "儲存",
        "cancel": "取消",
    },
    "enableRemoteSaving": "啟用遠端儲存",
    "blockquoteStyling": "引用區塊樣式",
    "dynamicModelRegistry": "動態模型目錄",
    "confirmInstallPluginViaPlugin": "您正嘗試透過另一個外掛安裝此外掛。若來源外掛不可信，可能會帶來安全風險。確定要繼續嗎？",
    "nodeOnlyRestoreLastChat": "啟動時重新開啟上次對話",
    "nodeOnlyScrollButtonType": "捲動按鈕類型",
    "scrollButtonTypeFour": "4 個按鈕",
    "scrollButtonTypeTwo": "2 個按鈕",
    "scrollButtonTypeOff": "關閉",
    "nodeOnlyServerSideRequests": "伺服器端請求",
    "pendingSendNotice": "尚未完成的送出：{chars} — 開啟對話後會繼續執行",
    "seperateParametersByModel": "依模型分別設定參數",
    "disableSeperateParameterChangeOnPresetChange": "切換預設集時不要變更獨立參數設定",
    "keepSessionAlive": "維持工作階段",
    "keepSessionAlivePip": "透過子母畫面（PiP）",
    "keepSessionAliveSound": "透過音訊",
    "toggleBindingLabel": "開關綁定",
    "togglePinToChat": "將開關綁定至對話",
    "togglePinLabel": "綁定",
    "togglePinSaved": "已綁定開關",
    "toggleSaveAsDefaultButton": "設為預設",
    "toggleSetDefaultConfirm": "要將目前的開關狀態儲存為新對話的預設值嗎？新對話建立時會直接綁定此狀態",
    "toggleDefaultSaved": "已儲存為開關預設值",
    "toggleDefaultSavedButton": "已儲存預設值",
    "toggleDefaultManage": "目前已儲存新對話使用的開關預設值",
    "toggleDefaultOverwrite": "以目前狀態覆寫",
    "toggleDefaultClear": "清除預設值",
    "toggleDefaultCleared": "已清除開關預設值。新對話建立時不會綁定開關",
    "toggleSaveAsPreset": "儲存為開關預設集",
    "toggleLoadPreset": "載入開關預設集",
    "togglePinUpdate": "儲存開關",
    "togglePinUpdateLabel": "儲存",

    "togglePinRemove": "要解除開關綁定嗎？",
    "togglePinUnbound": "已解除開關綁定",
    "togglePresetNamePrompt": "輸入開關預設集名稱",
    "togglePresetDelete": "── 刪除 ──",
    "togglePresetDeleteConfirm": (name: string) => `要刪除開關預設集「${name}」嗎？`,
    "togglePresetSelectTitle": "開關預設集",
    "togglePresetEmpty": "尚未儲存任何開關預設集",
    "togglePresetRename": "重新命名開關預設集",
    "togglePresetApplied": (name: string) => `已套用「${name}」預設集`,
    "togglePresetFilterShowAll": "顯示所有預設集",
    "togglePresetNoPromptPreset": "無提示詞預設集",
    "togglePresetEmptyFiltered": "目前的提示詞預設集沒有對應的開關預設集",
    "togglePresetApplyConfirm": "目前的開關設定會被覆寫。要套用嗎？",
    "togglePresetMismatchConfirm": "此開關預設集是為其他提示詞預設集儲存的，開關可能不相容。仍要套用嗎？",
    "togglePresetSaveNew": "儲存為新預設集",
    "togglePresetOverwrite": "覆寫",
    "togglePresetOverwriteConfirm": (name: string) => `要以目前的開關值覆寫「${name}」嗎？`,
    "togglePresetOverwritten": (name: string) => `已覆寫預設集「${name}」`,
    "togglePresetList": "開關預設集",
    "togglePresetMenuRename": "重新命名",
    "togglePresetMenuDuplicate": "建立副本",
    "togglePresetMenuDelete": "刪除",
    "togglePresetMenuOverwrite": "覆寫",
    "togglePresetMenuExport": "匯出",
    "togglePresetImport": "從檔案匯入",
    "togglePresetImported": (name: string) => `已匯入預設集「${name}」`,
    "togglePresetImportError": "無效的開關預設集檔案",
    "togglePresetSaved": (name: string) => `已儲存預設集「${name}」`,
    "togglePresetRenamed": (oldName: string, newName: string) => `已將「${oldName}」重新命名為「${newName}」`,
    "togglePresetDuplicated": (name: string) => `已建立副本「${name}」`,
    "togglePresetDeleted": (name: string) => `已刪除預設集「${name}」`,
    "togglePresetExported": (name: string) => `已匯出預設集「${name}」`,
    "longPressToPopupEditor": "長按以開啟彈出式編輯器",
    "showInputActionBar": "顯示輸入操作列",
    "importSaveFolderHeader": "將存檔載入 PocketRisu",
    "importSaveZip": "從存檔資料夾載入（上傳 ZIP）",
    "importSaveZipDesc": "請將現有 Risuai 專案的 save 資料夾壓縮成 ZIP，並在此上傳以匯入資料。ZIP 過大時可能無法上傳；若發生此情況，請直接將 save 資料夾複製到伺服器的 save 目錄，再重新啟動，系統就會自動進行移轉",
    "importSaveFolderScanning": "正在掃描存檔資料夾...",
    "importSaveFolderImporting": "正在匯入存檔資料夾...",
    "importSaveFolderConfirmZip": (name: string, size: string) => `要上傳「${name}」（${size}）並匯入嗎？這會取代目前的資料`,
    "importSaveFolderNoDatabase": "存檔資料夾中沒有資料庫檔案（database/database.bin），無法繼續匯入",
    "importSaveFolderSuccess": "匯入完成",
    "cleanupMigratedFiles": "清理已移轉的存檔檔案",
    "cleanupMigratedDesc": "若您曾手動將存檔檔案複製到伺服器的 save 資料夾，此功能可在移轉完成後刪除殘留的原始檔案，以釋放磁碟空間",
    "cleanupMigratedConfirm": (count: number, size: string) => `要刪除 ${count} 個已移轉的 hex 檔案（${size}）嗎？這些資料已存在資料庫中`,
    "cleanupMigratedNoFiles": "沒有可清理的已移轉檔案",
    "cleanupMigratedNotReady": "移轉尚未完成，無法清理",
    "cleanupMigratedSuccess": (count: number, size: string) => `已移除 ${count} 個檔案，釋放 ${size}`,
    "cleanupMigratedCleaning": "正在清理已移轉檔案...",
    // NanoGPT 儀表板
    "nanoGPTLoadingAccountInfo": "正在載入帳號資訊…",
    "nanoGPTCreditBalance": "帳戶餘額：",
    "nanoGPTSubscription": "訂閱",
    "nanoGPTGraceUntil": (date: string) => `寬限期至 ${date}`,
    "nanoGPTNoActiveSubscription": "目前沒有有效訂閱",
    "nanoGPTCancelsAtPeriodEnd": (date: string) => `將於本期結束時取消（${date}）`,
    "nanoGPTWeeklyTokens": (pct: string) => `每週內含輸入 Token 額度 — 已使用 ${pct}`,
    "nanoGPTDailyTokens": (pct: string) => `每日內含輸入 Token 額度 — 已使用 ${pct}`,
    "nanoGPTDailyImages": (pct: string) => `每日內含圖片額度 — 已使用 ${pct}`,
    "nanoGPTResets": (date: string) => `於 ${date} 重設`,
    "nanoGPTUsed": (n: string) => `已使用 ${n}`,
    "nanoGPTRemaining": (n: string) => `剩餘 ${n}`,
    "nanoGPTRenews": (date: string) => `續訂：${date}`,
    "nanoGPTCouldNotLoadAccountInfo": "無法載入帳號資訊",
    "nanoGPTWeeklyTokensLabel": "每週內含輸入 Token 額度",
    "nanoGPTDailyTokensLabel": "每日內含輸入 Token 額度",
    "nanoGPTDailyImagesLabel": "每日內含圖片額度",
    "nanoGPTUsedLabel": "已使用",
    "nanoGPTRemainingLabel": "剩餘",
    "nanoGPTResetsLabel": "重設",
    "nanoGPTRenewsLabel": "續訂：",
    // NanoGPT 供應商選擇器
    "nanoGPTProvider": "供應商",
    "nanoGPTProviderPayAsYouGoOnly": "（僅適用於隨用隨付模式）",
    "nanoGPTProviderAuto": "自動",
    "nanoGPTProviderFree": "免費",
    "nanoGPTProviderInput": "輸入",
    "nanoGPTProviderOutput": "輸出",
    "nanoGPTProviderQuantization": "量化",
    "nanoGPTProviderUndisclosed": "未公開",
    "nanoGPTProviderCache": "快取",
    "nanoGPTProviderCacheSupported": "支援",
    "nanoGPTProviderCacheNotSupported": "不支援",
    "nanoGPTProviderCacheRead": "快取讀取",
    // NanoGPT 設定
    "nanoGPTUseSubscriptionEndpoint": "使用訂閱專用端點與模型",
    // 模型格狀清單
    "modelGridCouldNotLoad": "無法載入模型清單。請檢查您的 API 金鑰",
    "modelGridNoModelsMatch": (q: string) => `找不到符合「${q}」的模型`,
    "modelGridContext": (n: string) => `上下文：${n}`,
    "nanoGPTSelectFromList": "從清單中選擇",
    "nanoGPTManualInput": "手動輸入",
    "nanoGPTManualModelSelect": "手動選擇模型",
    "searchSettingsPlaceholder": "搜尋設定...",
    "searchSettingsNoResults": "找不到符合的設定",
    "searchSettingsHint": "依設定名稱或關鍵字搜尋",
    // 遠端存取（Cloudflare Quick Tunnel）
    "remoteAccess": "遠端存取",
    "remoteAccessDesc": "使用遠端存取連結，從其他裝置連線至此 PocketRisu 伺服器",
    "remoteAccessOpen": "開啟遠端存取",
    "remoteAccessClose": "關閉遠端存取",
    "remoteAccessCloseConfirm": "要關閉遠端存取嗎？目前的連結將失效",
    "remoteAccessDownloading": "正在下載 cloudflared...",
    "remoteAccessStarting": "正在啟動 Tunnel...",
    "remoteAccessCopyUrl": "複製 URL",
    "remoteAccessCopied": "已複製！",
    "remoteAccessDisabled": "伺服器設定已停用遠端存取",
    "remoteAccessError": "Tunnel 錯誤",
    "remoteAccessRetry": "重試",
    "remoteAccessQrHint": "掃描 QR Code 以連線",
    "remoteAccessWarning": "請勿與他人分享 QR Code 或連結。任何取得連結的人都能自由存取您的伺服器。若不慎分享，請關閉連線並建立新的連結",
    "remoteAccessInfo": "關閉遠端存取或重新啟動伺服器後，連結就會失效；每次都會產生新的連結。即使關閉此頁面或瀏覽器，連線仍會保持啟用",
    "remoteAccessTermuxWarning": "Cloudflare Quick Tunnel 無法在 Termux 上使用。請改用 Tailscale 或其他遠端存取工具",

    // 不安全（HTTP）連線警告
    "httpInsecureWarningTitle": "目前使用 HTTP 連線",
    "httpInsecureWarningBody": "外掛等部分功能可能無法運作。請使用「遠端存取」功能建立 HTTPS 連線",
    "httpInsecureOpenRemoteAccess": "開啟設定",
    "transferSizeWarningTitle": "傳輸資料大小超過建議上限",
    "transferSizeWarningBody": "目前約為 {{size}}；透過遠端存取儲存時可能失敗。停用不再使用的角色可減少傳輸資料大小",
    "transferSizeOpenCharacterManager": "管理角色",
    "transferSizeDismiss": "本次工作階段不再顯示",
    "transferSizeWarningToggle": "超過建議上限時在主畫面顯示警告",
    "transferSizeWarningToggleDesc": "若連線方式沒有上傳大小限制，可以關閉。經過 Cloudflare（Quick Tunnel，或開啟代理的自有網域）時有 100 MB 上限，請保持開啟",

    // 系統頁面
    "system": "系統",
    "systemLogs": "系統記錄",
    "systemLogsDesc": "查看此伺服器與已連線瀏覽器擷取到的錯誤、警告與資訊事件",
    "systemLogsEmpty": "目前沒有記錄",
    "systemLogsEmptyDesc": "發生錯誤或警告時會顯示在這裡",
    "systemLogsEmptyButMore": "目前載入的項目沒有符合用戶端篩選條件的結果。可載入更多以繼續往前搜尋",
    "systemLogsSearchPlaceholder": "搜尋訊息、來源、平台或用戶端 ID",
    "systemLogsLoadMore": "載入更多",
    "systemLogsRefresh": "重新整理",
    "systemLogsCopyAll": "複製目前顯示內容",
    "systemLogsCopyEntry": "複製",
    "systemLogsClearAll": "全部清除",
    "systemLogsClearConfirm": "要刪除所有記錄項目嗎？此操作無法復原",
    "systemLogsCopied": "已複製至剪貼簿",
    "systemLogsFiltered": (shown: number, total: number) => `顯示 ${shown}／${total}`,
    "systemLogsLevelAll": "所有層級",
    "systemLogsLevelError": "錯誤",
    "systemLogsLevelWarning": "警告",
    "systemLogsLevelInfo": "資訊",
    "systemLogsOriginAll": "全部",
    "systemLogsOriginClient": "用戶端",
    "systemLogsOriginServer": "伺服器",
    "systemLogsFailedLoad": "無法載入系統記錄",
    "systemLogsLoading": "載入中...",
    "pluginStorageTab": "外掛儲存空間",
    "pluginStorageDesc": "查看、編輯及刪除外掛儲存的資料。外掛資料共用同一個全域 Namespace，不會依外掛分開",
    "pluginStorageBackendSave": "存檔",
    "pluginStorageBackendSaveDesc": "儲存在存檔中 · 會隨存檔一起移轉",
    "pluginStorageBackendLocal": "本機",
    "pluginStorageBackendLocalDesc": "以 localStorage 儲存 · 僅支援字串 · 僅限此裝置",
    "pluginStorageBackendIdb": "伺服器儲存空間",
    "pluginStorageBackendIdbDesc": "儲存在伺服器上 · 支援 JSON 與二進位資料 · 不包含在存檔備份中",
    "pluginStorageSearchKey": "搜尋鍵名...",
    "pluginStorageSearchValue": "搜尋值...",
    "pluginStorageRefresh": "重新整理",
    "pluginStorageEmpty": "沒有項目",
    "pluginStorageLoadError": "無法載入儲存資料",
    "pluginStorageNotLoaded": "開啟時載入",
    "pluginStorageSave": "儲存",
    "pluginStorageFormatJson": "格式化 JSON",
    "pluginStorageMetaType": "類型",
    "pluginStorageMetaSize": "大小",
    "pluginStorageMetaBinarySize": "二進位資料大小",
    "pluginStorageMetaMime": "MIME 類型",
    "pluginStorageMetaFileName": "檔案名稱",
    "pluginStorageMetaChars": "字元數",
    "pluginStorageOwner": "來源（推測）",
    "pluginStorageOwnerUnknown": "未知",
    "pluginStorageDeleted": "已刪除",
    "pluginStorageJsonError": (msg: string) => `JSON 解析失敗：${msg}`,
    "pluginStorageSaved": (key: string) => `已儲存「${key}」`,
    "pluginStorageDeleteConfirm": (key: string) => `要刪除「${key}」嗎？`,
    "pluginStorageBulkDeleteShown": (n: number) => `刪除目前顯示項目（${n}）`,
    "pluginStorageBulkDeleteAll": (n: number) => `全部清除（${n}）`,
    "pluginStorageBulkDeleteConfirm": (backend: string, n: number) => `要從 ${backend} 儲存後端刪除 ${n} 個項目嗎？此操作無法復原`,
    "pluginStorageBulkDeleteAllConfirm": (backend: string, n: number) => `要從 ${backend} 儲存後端刪除全部 ${n} 個外掛儲存項目嗎？此操作無法復原`,
    "pluginStorageBulkDeleted": (n: number) => `已刪除 ${n} 個項目`,
    "systemLogsFilters": "篩選條件",
    "systemLogsFilterLevel": "層級",
    "systemLogsFilterOrigin": "來源端",
    "systemLogsFilterSource": "來源",
    "systemLogsFilterDevice": "裝置",
    "systemLogsFilterClear": "重設篩選條件",
    "systemLogsFilterActive": (count: number) => count === 0 ? '' : `已排除 ${count} 項`,
    "systemLogsExplicitOnly": "只顯示明確記錄",
    "systemLogsExplicitOnlyHint": "排除 console、未捕捉例外與框架自動擷取的記錄",

    // 請求記錄／使用量（系統設定）
    "requestLogsTab": "請求記錄",
    "requestLogsDesc": "記錄每次送往供應商的請求內容、回應與耗時",
    "requestLogsFilters": "篩選條件",
    "requestLogsFilterClear": "清除篩選條件",
    "requestLogsFilterActive": (count: number) => count === 0 ? "" : `已啟用 ${count} 項`,
    "requestLogsFilterCategory": "類型",
    "requestLogsFilterSource": "來源",
    "requestLogsFilterResult": "結果",
    "requestLogsCategoryLlm": "LLM",
    "requestLogsCategoryTts": "語音",
    "requestLogsCategoryImage": "圖片",
    "requestLogsCategoryTranslate": "翻譯",
    "requestLogsCategoryEmbedding": "Embedding",
    "requestLogsCategoryOther": "其他",
    "requestLogsSourceMain": "對話",
    "requestLogsSourceTranslate": "翻譯",
    "requestLogsSourceMemory": "記憶",
    "requestLogsSourceEmotion": "情緒",
    "requestLogsSourceSub": "輔助模型",
    "requestLogsSourcePreview": "預覽",
    "requestLogsSourceTest": "測試",
    "requestLogsSourceTts": "語音",
    "requestLogsSourceImage": "圖片",
    "requestLogsSourcePlugin": "外掛",
    "requestLogsSourceOther": "其他",
    "requestLogsResultSuccess": "成功",
    "requestLogsResultFailed": "失敗",
    "requestLogsRouteDirect": "直接連線",
    "requestLogsRouteProxy": "Proxy",
    "requestLogsRouteJob": "後端呼叫",
    "requestLogsSearchPlaceholder": "依 URL、模型或錯誤訊息搜尋",
    "requestLogsRefresh": "重新整理",
    "requestLogsClearAll": "全部清除",
    "requestLogsClearConfirm": "要刪除所有已儲存的請求記錄嗎？使用量統計資料會保留",
    "requestLogsEmpty": "目前沒有記錄",
    "requestLogsEmptyDesc": "您送出的請求會記錄在這裡",
    "requestLogsEmptyButMore": "目前的篩選條件沒有結果。可嘗試載入更多",
    "requestLogsLoading": "載入中...",
    "requestLogsFailedLoad": "無法載入請求記錄",
    "requestLogsLoadMore": "載入更多",
    "requestLogsCount": (shown: number, total: number) => shown === total ? `${total}` : `${shown}／${total}`,
    "requestLogsDuration": "耗時",
    "requestLogsFirstToken": "首個 Token",
    "requestLogsTokens": "Token",
    "requestLogsRequestHeaders": "Request Headers",
    "requestLogsRequestBody": "Request Body",
    "requestLogsResponse": "回應",
    "requestLogsError": "錯誤",
    "requestLogsCopied": "已複製至剪貼簿",
    "requestLogsTruncated": "已截斷",
    "requestLogsEnabled": "記錄請求",
    "requestLogsEnabledDesc": "關閉後不會記錄新的請求，使用量統計也會停止累積",
    "requestLogsStreamUsage": "收集串流請求的 Token 使用量",
    "requestLogsStreamUsageDesc": "要求供應商回報串流回應的 Token 使用量。部分供應商會因此回傳 400 錯誤；若發生此情況，請關閉此選項",
    "requestLogsStorage": (used: string, max: string) => `儲存空間 ${used}／${max}`,

    "usageTab": "使用量",
    "usageDesc": "LLM 請求的 Token 使用量。沒有 Token 的請求（語音、圖片）不會計入",
    "usageRequests": "請求數",
    "usageInputTokens": "輸入 Token",
    "usageOutputTokens": "輸出 Token",
    "usageCachedTokens": "快取 Token",
    "usageChartTitle": "Token 使用量",
    "usageByModel": "依模型",
    "usageBySource": "依來源",
    "usageModel": "模型",
    "usageAvgDuration": "平均延遲",
    "usageFailed": "失敗",
    "usagePeriod7d": "7 天",
    "usagePeriod30d": "30 天",
    "usagePeriod90d": "90 天",
    "usagePeriodAll": "全部",
    "usageEmpty": "尚無使用量記錄",
    "usageEmptyDesc": "送出請求後會逐步累積統計資料",
    "usageLoading": "載入中...",
    "usageFailedLoad": "無法載入使用量",
    "usageClearConfirm": "要刪除所有使用量統計嗎？此操作無法復原",
    "usageClearAll": "清除統計資料",

    // 儲存空間儀表板
    "systemDashboard": "儀表板",
    "storageDashboardDesc": "查看儲存空間用量、找出大型項目並釋放空間",
    "storageRefresh": "重新整理",
    "storageLoading": "載入中...",
    "storageFailedLoad": "無法載入儲存空間統計",

    // 磁碟使用量區段（macOS 風格長條圖）
    "storageDiskUsage": "儲存空間",
    "storageDiskHeader": (used: number, total: number) =>
        `已使用 ${(used / 1024 / 1024 / 1024).toFixed(2)} GB／共 ${(total / 1024 / 1024 / 1024).toFixed(2)} GB`,
    "storageDiskHeaderUnknown": "無法取得磁碟容量",
    "storageDiskOther": "其他（系統與應用程式）",
    "storageDiskFree": "可用空間",
    "storageDiskRisuTotal": (size: number) => `PocketRisu 總計：${(size / 1024 / 1024).toFixed(1)} MB`,

    // 各列標籤（顯示於包含 ⓘ 說明的明細清單）
    "storageRowDbFile": "risuai.db",
    "storageRowDbFileDesc": "主要 SQLite 資料庫檔案，包含所有對話、角色、資源與設定",
    "storageRowWal": "WAL（Write-Ahead Log）",
    "storageRowWalDesc": "暫時性的交易記錄。儲存資料時會先寫入此處，再合併至主要檔案；使用期間出現屬正常情況",
    "storageRowShm": "SHM（共享記憶體）",
    "storageRowShmDesc": "SQLite 用於 WAL 的共享記憶體索引。容量很小且屬暫存資料，需要時會自動重新建立",
    "storageRowFileBackups": "磁碟備份（.bin）",
    "storageRowFileBackupsDesc": "手動匯出的備份，儲存在磁碟的 backups/ 資料夾",
    "storageRowKvDatabase": "database.bin（使用中）",
    "storageRowKvDatabaseDesc": "risuai.db 中唯一的 BLOB，包含角色中繼資料、對話與設定，受單一 BLOB 2 GB 上限限制",
    "storageRowTransferSize": "傳輸資料大小（不含對話）",
    "storageRowTransferSizeLimit": "建議 ≤ {{limit}}",
    "storageRowTransferSizeDesc": "儲存時送往伺服器的資料大小（以此裝置上次儲存為準）。超過建議上限時，透過遠端存取儲存可能失敗；停用不再使用的角色可降低資料量",
    "storageRowKvDbBackups": "資料庫內部備份",
    "storageRowKvDbBackupsDesc": "儲存在 risuai.db 內的 database.bin 自動快照。系統會輪替舊快照，使總量維持在約 500 MB 以內",
    "storageRowKvAssets": "角色資源",
    "storageRowKvAssetsDesc": "角色卡、情緒立繪、額外資源、使用者人設圖示及其他類似媒體",
    "storageRowKvInlay": "內嵌圖片",
    "storageRowKvInlayDesc": "內嵌於對話訊息中的圖片（內嵌圖、縮圖與中繼資料）",
    "storageRowKvRemotes": "遠端對話資料",
    "storageRowKvRemotesDesc": "各角色的遠端同步快取（remotes/{chaId}.local.bin）",
    "storageRowKvColdStorage": "冷儲存",
    "storageRowKvColdStorageDesc": "舊版／休眠用的儲存層，通常為空",
    "storageRowKvArchive": "已停用角色",
    "storageRowKvArchiveDesc":
        "已停用角色的完整資料（包含對話與資源清單）及索引。即使角色重新啟用也不會自動刪除；備份一律會將它們視為完整角色納入",
    "storageRowKvUncategorized": "其他資料",
    "storageRowKvUncategorizedDesc": "不符合任何已知分類的鍵值，通常是移轉殘留或暫存項目",
    "storageRowSqliteOverhead": "SQLite 結構占用空間",
    "storageRowSqliteOverheadDesc": "SQLite 必須保留的結構頁面，例如索引、頁面標頭與對齊填充。這些不是使用者資料，也無法透過清理移除；會隨資料量自然增加",
    "storageRowReclaimablePages": "SQLite 可釋放空間",
    "storageRowReclaimablePagesDesc": "刪除資料後留下的空白頁面，也就是 SQLite 額外空間中可釋放的部分。數值與下方「清理 SQLite 額外空間」長條圖的黃色區段相同；清理會釋放全部這類頁面",
    "storageRowReclaimable": (size: number) =>
        `可釋放 ${(size / 1024 / 1024).toFixed(1)} MB — 執行下方清理即可釋放`,
    "storageInternalOnly": "顯示完整磁碟資訊",
    "storageInternalOnlyHint": "關閉時只顯示 PocketRisu 項目；開啟時會以整顆磁碟為基準，同時顯示系統與可用空間",

    // 2 GB BLOB 上限（獨立區段）
    "storageBlobLimit": "2 GB BLOB 上限",
    "storageBlobLimitDesc": "SQLite 單一資料列的值上限約為 2 GB。database.bin 只占一列，因此所有對話與設定合計不能超過此限制。接近上限時，儲存可能開始失敗",
    "storageBlobThreshold": (used: number, max: number, pct: number) =>
        `2 GB 的 ${pct.toFixed(1)}%（${(used / 1024 / 1024 / 1024).toFixed(2)}／${(max / 1024 / 1024 / 1024).toFixed(2)} GB）`,
    "storageBlobThresholdWarn": "正在接近單一 BLOB 2 GB 上限。請減少對話或資源",
    "storageBlobThresholdCrit": "嚴重警告：已非常接近 2 GB BLOB 上限，儲存可能開始失敗",

    "storageOptimize": "立即清理",
    "storageOptimizing": "清理中...",
    "storageOptimizeHeader": (dbSize: number, reclaim: number) =>
        `${(dbSize / 1024 / 1024 / 1024).toFixed(2)} GB 中有 ${(reclaim / 1024 / 1024).toFixed(1)} MB 可釋放`,
    "storageOptimizeBarUsed": "使用中",
    "storageOptimizeBarReclaimable": "可釋放",
    "storageOptimizeWhat": "刪除角色、對話或資源後，資料庫只會將該空間標記為可重用，不會立即縮小檔案。清理會重寫資料庫並移除未使用空間，以減少磁碟占用；資料內容不會被修改",
    "storageOptimizeWhen": "大量刪除資料後，或上方長條圖的空白空間比例增加時可執行。清理期間會暫停儲存一小段時間（通常數秒；非常大的資料庫可能需要數十秒）",
    "storageOptimizeConfirm": "要立即清理嗎？伺服器儲存會暫停數秒",
    "storageOptimizeNeedsSpace": (need: number, free: number) =>
        `磁碟空間不足。約需 ${(need / 1024 / 1024).toFixed(0)} MB，目前可用 ${(free / 1024 / 1024).toFixed(0)} MB`,
    "storageOptimizeDone": (reclaimed: number, ms: number) =>
        `已在 ${(ms / 1000).toFixed(1)} 秒內釋放 ${(reclaimed / 1024 / 1024).toFixed(1)} MB 空間`,
    "storageOptimizeFailed": "清理失敗",

    "storageCleanup": "清理 SQLite 額外空間",

    "storageOrphan": "未被引用的媒體",
    "storageOrphanHeader": (count: number, size: number) =>
        `${count} 個檔案 · ${(size / 1024 / 1024).toFixed(1)} MB`,
    "storageOrphanWhat":
        "沒有任何角色、模組或使用者人設引用的圖片檔案。刪除角色或取代資源後可能留下這些檔案",
    "storageOrphanWhen":
        "刪除後無法復原；若其中有重要內容，請先建立備份。清除後再執行上方的「清理 SQLite 額外空間」，才能實際縮小檔案",
    "storageOrphanUnavailable":
        "目前尚無法掃描。請等資料庫載入伺服器記憶體後再重新整理",
    "storageOrphanPurge": "清除未被引用的媒體",
    "storageOrphanPurging": "正在清除未被引用的媒體...",
    "storageOrphanConfirm": (count: number, size: number) =>
        `要刪除 ${count} 個未被引用的媒體檔案（${(size / 1024 / 1024).toFixed(1)} MB）嗎？此操作無法復原`,
    "storageOrphanDone": (count: number, size: number) =>
        `已刪除 ${count} 個檔案（${(size / 1024 / 1024).toFixed(1)} MB）`,
    "storageOrphanFailed": "清除未被引用的媒體失敗",
    "storageOrphanAutoClean": "啟動時自動清除",
    "storageOrphanAutoCleanDesc":
        "每次開啟應用程式時自動刪除未被引用的媒體。預設關閉；掃描器可能尚未辨識部分有效引用，因此手動清除較安全",

    "storageWalCleanup": "手動清理 WAL",
    "storageWalCleanupHeader": (walSize: number) => `目前 WAL：${(walSize / 1024 / 1024).toFixed(1)} MB`,
    "storageWalCleanupWhat": "SQLite 的 WAL 檔案（risuai.db-wal）會先收集最近的變更，再合併回主要資料庫。系統每 5 分鐘會在背景執行 checkpoint，但匯入備份或上傳大型資源等大量寫入操作仍可能暫時讓 WAL 膨脹",
    "storageWalCleanupWhen": "WAL 檔案看起來很大，且希望立即釋放磁碟空間時可使用。此操作很輕量（通常只需數毫秒），也不像「最佳化」需要額外可用空間；資料內容不會被修改",
    "storageWalCleanup_btn": "清理 WAL",
    "storageWalCleanuping": "正在清理 WAL...",
    "storageWalCleanupConfirm": "要立即清理 WAL 嗎？伺服器儲存會短暫暫停",
    "storageWalCleanupDone": (reclaimed: number, ms: number) =>
        `已在 ${ms} 毫秒內釋放 ${(reclaimed / 1024 / 1024).toFixed(1)} MB 空間`,
    "storageWalCleanupNoop": "WAL 目前無需清理",
    "storageWalCleanupFailed": "WAL 清理失敗",

    "storageBackups": "備份",
    "storageBackupsManage": "管理備份",
    "storageBackupsAuto": "快照（僅資料庫）",
    "storageBackupsAutoDesc": "定期自動建立的快照，用於快速復原。快照儲存在 risuai.db 內，超過設定上限時會優先清除最舊項目。不包含角色資源與內嵌圖片",
    "storageBackupsManual": "伺服器備份",
    "storageBackupsManualDesc": "包含角色資源與內嵌圖片的完整備份，直接儲存在伺服器上；可變更儲存位置",
    "storageBackupsCount": (count: number, size: number) =>
        `${count} 份 · ${(size / 1024 / 1024).toFixed(1)} MB`,
    "storageBackupsRange": (oldest: string, newest: string) => `最新 ${newest} · 最舊 ${oldest}`,
    "storageBackupsEmpty": "無",

    "storageCharacters": "各角色儲存用量",
    "storageCharactersDesc": "估算每個角色的角色卡、媒體與對話資料大小",
    "storageCharactersMeasure": "計算用量",
    "storageCharactersMeasuring": "計算中...",
    "storageCharactersDone": (ms: number, count: number) =>
        `已在 ${(ms / 1000).toFixed(1)} 秒內完成 ${count.toLocaleString()} 個角色的用量計算。對話大小為估算值`,
    "storageCharactersCard": "角色卡",
    "storageCharactersImage": "媒體",
    "storageCharactersChat": "對話",
    "storageCharactersTrashed": "垃圾桶",
    "storageCharactersGoTo": "前往此角色",
    "storageCharactersDeactivated": "已停用",
    "storageArchiveOrphanHeader": (count: number, size: number) =>
        `未被引用的已停用角色資料：${count} 列，${(size / 1024 / 1024).toFixed(1)} MB`,
    "storageArchiveOrphanDesc":
        "這些是已重新啟用、已刪除，或因匯入備份而被取代之角色所留下的資料。系統會刻意保留，以便較舊的快照仍能還原",
    "storageArchiveOrphanPurge": "清除已儲存資料",
    "storageArchiveOrphanConfirm": (count: number, size: number) =>
        `要刪除 ${count} 列未被引用的已停用角色資料（${(size / 1024 / 1024).toFixed(1)} MB）嗎？引用這些資料的舊快照之後將無法再開啟對應角色。此操作無法復原`,
    "storageArchiveOrphanDone": (count: number, size: number) =>
        `已清除 ${count} 列資料（${(size / 1024 / 1024).toFixed(1)} MB）`,
    "storageCharactersDeactivatedMissing": "已停用 · 資料遺失",
    "storageCharactersOrphan": (count: number, size: number) =>
        `未被引用的媒體：${count} 個項目，${(size / 1024 / 1024).toFixed(1)} MB`,
    "storageCharactersEmpty": "沒有角色",
    "storageLoadMore": (remaining: number) => `顯示更多（剩餘 ${remaining.toLocaleString()} 項）`,
    "storageShowingOf": (shown: number, total: number) => `顯示 ${shown.toLocaleString()}／${total.toLocaleString()}`,

    "storageModules": "各模組儲存用量",
    "storageModulesDesc": "每個模組的本體與資源大小",
    "storageModulesMeasure": "計算用量",
    "storageModulesMeasuring": "計算中...",
    "storageModulesDone": (ms: number, count: number) =>
        `已在 ${(ms / 1000).toFixed(1)} 秒內完成 ${count.toLocaleString()} 個模組的用量計算`,
    "storageModulesBody": "本體",
    "storageModulesAssets": "資源",
    "storageModulesEmpty": "沒有模組",

    "storageDebug": "偵錯資訊",

    // 資料移轉（原「帳號與檔案」）
    "migration": "資料移轉",
    "migrationDesc": "在 Risuai（或相容系統）與 PocketRisu 之間移轉資料：可從上游匯入，也可匯出為上游相容格式",
    "migrationInfoBackupMoved": "伺服器備份、本機備份與資料庫快照已移至「系統 → 備份」",
    "migrationGotoBackupTab": "開啟備份分頁",
    "migrationLegacyAccordion": "Risuai 格式備份（舊版）",
    "migrationLegacyDesc": "用於建立與匯出上游 Risuai 相容格式備份的工具。一般日常備份請使用「備份」分頁",
    "migrationSaveFolderAccordion": "從 NodeRisu 匯入 save 資料夾",
    "migrationSaveFolderDesc": "用於匯入先前在 NodeRisu／Risuai 使用的 save 資料夾",
    "migrationLoadUpstreamBackup": "載入上游 Risuai 本機備份",
    "risuAccountImport": "從 RisuAI 帳號匯入",
    "risuAccountImportDesc": "若您曾在 risuai.xyz 開啟「將資料儲存至帳號」，此功能會將帳號中的角色、對話、設定與圖片移至此伺服器。網頁版的備份檔案無法開啟時，請使用此功能。",
    "risuAccountLogin": "登入 RisuAI",
    "risuAccountLoginTitle": "RisuAI 帳號登入",
    "risuAccountLoginDesc": "您的 ID 與密碼只會傳送給 RisuAI。RisuAI 回傳的登入 Token 只會保留在此伺服器的記憶體中直到匯入結束，不會被儲存。",
    "risuAccountChecking": "正在確認帳號資料…",
    "risuAccountCheckingRemotes": (n: number) => `正在確認帳號資料…（已讀取 ${n.toLocaleString()} 個角色）`,
    "risuAccountSummaryCharacters": (n: number) => `${n.toLocaleString()} 個角色`,
    "risuAccountSummaryChats": (n: number) => `${n.toLocaleString()} 個對話`,
    "risuAccountSummaryAssets": (n: number, staged: number) => `${n.toLocaleString()} 張圖片${staged > 0 ? `（已下載 ${staged.toLocaleString()} 張）` : ""}`,
    "risuAccountSummaryCold": (n: number) => `${n.toLocaleString()} 個封存項目`,
    "risuAccountEstimate": (time: string) => `預估時間：約 ${time}`,
    "risuAccountMinutes": (n: number) => `${n.toLocaleString()} 分鐘`,
    "risuAccountHours": (h: number, m: number) => `${h.toLocaleString()} 小時 ${m} 分鐘`,
    "risuAccountUnresolvedRemotes": (n: number) => `有 ${n.toLocaleString()} 個角色未儲存在帳號中，無法匯入。若這些角色是在 RisuAI 桌面應用程式中儲存的，請在該應用程式中使用一般備份移轉。`,
    "risuAccountSkipped": (n: number) => `將略過 ${n.toLocaleString()} 個名稱無效的項目。`,
    "risuAccountDamaged": (n: number, names: string) => `帳號資料中有 ${n.toLocaleString()} 個項目已損毀，無法讀取（${names}）。取代資料時不會包含這些項目。`,
    "risuAccountStartWarn": "匯入開始後，在結束前都無法使用 PocketRisu；結束後，此伺服器上的所有資料都會被取代為帳號資料。",
    "risuAccountSnapshotNote": "帳號資料以剛才登入的時間點為準。下載期間在 RisuAI 網頁版進行的對話不會包含在內。",
    "risuAccountInlayNote": "插入對話中的圖片（內嵌圖片）只儲存在瀏覽器中，因此不會匯入。",
    "risuAccountStart": "開始匯入",
    "risuAccountConfirm1Title": "您的資料將被取代為帳號資料",
    "risuAccountConfirm1": (time: string) => `此伺服器上的所有角色、對話、設定與圖片都會被取代為 RisuAI 帳號資料。下載期間（約 ${time}）無法使用 PocketRisu。`,
    "risuAccountContinue": "繼續",
    "risuAccountConfirm2Title": "要取代您的資料嗎？",
    "risuAccountConfirm2": "若要復原，必須還原取代前一刻建立的資料庫快照。快照不包含圖片，如有需要請先備份圖片。",
    "risuAccountConfirmStart": "取代資料並開始",
    "risuAccountSaveFailed": "部分變更未能儲存，因此未開始匯入。請稍後再試。",
    "risuAccountScreenTitle": "正在從 RisuAI 帳號匯入",
    "risuAccountScreenDesc": "結束後，您的資料會被取代為帳號資料，應用程式也會自動重新整理。",
    "risuAccountStepCheck": "確認帳號資料",
    "risuAccountStepCold": "封存項目",
    "risuAccountStepAssets": "圖片",
    "risuAccountStepApply": "取代資料",
    "risuAccountRemaining": (time: string) => `剩餘約 ${time}`,
    "risuAccountScreenNote": "即使關閉此視窗，伺服器也會繼續下載。在其他裝置上開啟也會看到此畫面。為避免造成 RisuAI 伺服器的負擔，每秒只下載一個項目。",
    "risuAccountCancel": "取消匯入",
    "risuAccountCancelConfirm": "要取消匯入嗎？已下載的檔案會被刪除，您目前的資料會維持原樣。",
    "risuAccountPaused": "無法連線至 RisuAI 伺服器，因此已停止。請稍後再試。",
    "risuAccountKeptFiles": "已下載的檔案會保留。",
    "risuAccountRetry": "重試",
    "risuAccountNeedsLogin": "RisuAI 登入已過期。重新登入即可繼續；已下載的檔案不會重新下載。",
    "risuAccountRelogin": "重新登入",
    "risuAccountInterruptedTitle": "有匯入作業已中斷",
    "risuAccountInterrupted": "伺服器已重新啟動，匯入因此停止。使用同一個帳號重新登入後，只會下載剩餘的部分並完成資料取代。",
    "risuAccountStagedFiles": (staged: number, total: number) => `已下載的檔案：${staged.toLocaleString()}/${total.toLocaleString()}`,
    "risuAccountDataUnchanged": "您目前的資料仍未變更。",
    "risuAccountReloginResume": "重新登入並繼續",
    "risuAccountDownloaded": "下載完成",
    "risuAccountMissingAsk": (n: number) => `有 ${n.toLocaleString()} 個項目在帳號中找不到或無法讀取。要在不含這些項目的情況下取代資料嗎？`,
    "risuAccountMissingAssets": (n: number) => `${n.toLocaleString()} 張圖片`,
    "risuAccountMissingCold": (n: number) => `${n.toLocaleString()} 個封存項目`,
    "risuAccountMissingNotFound": "帳號中不存在",
    "risuAccountMissingUnreadable": "無法讀取",
    "risuAccountApplyAuto": "若沒有缺少的項目，會直接取代資料，不會顯示此畫面。",
    "risuAccountApplyWithout": "不含這些項目直接取代",
    "risuAccountApplyFailed": "無法取代資料。您目前的資料未變更。",
    "risuAccountApplyRetry": "再試一次",
    "risuAccountApplyingTitle": "正在取代您的資料",
    "risuAccountApplyingDesc": "這需要數秒到數分鐘。結束後應用程式會自動重新整理。",
    "risuAccountDone": "匯入完成。正在重新整理…",
    "risuAccountImportActive": "正在進行匯入\n\n另一台裝置已開始從 RisuAI 帳號匯入，因此無法在此儲存。重新整理即可查看進度。",
    "risuAccountErrorLoginFailed": "RisuAI 拒絕了登入。請重新登入。",
    "risuAccountErrorNoData": "此帳號沒有已儲存的資料。請確認 RisuAI 中的「將資料儲存至帳號」已開啟。",
    "risuAccountErrorRequestFailed": "無法連線至 RisuAI 伺服器。請稍後再試。",
    "risuAccountErrorUnreadable": "無法讀取帳號資料。",
    "risuAccountErrorRateLimited": "RisuAI 伺服器要求稍候再傳送更多請求。請稍後再試。",
    "risuAccountErrorDiskFull": "伺服器的可用磁碟空間不足。",
    "risuAccountErrorMismatch": "這不是開始匯入時使用的帳號。請登入同一個帳號。",
    "risuAccountErrorStagedUnreadable": "無法讀取已下載的帳號資料。請取消匯入並重新開始。",

    // 系統 → 備份分頁
    "systemBackups": "備份",
    "backupTabDesc": "集中管理快照、完整備份與本機備份",

    "backupSnapshot": "快照（僅資料庫）",
    "backupSnapshotEmpty": "沒有快照",
    "backupSnapshotRestore": "從此快照還原",
    "backupSnapshotDelete": "刪除快照",
    "backupSnapshotDeleteConfirm": (when: string) => `要刪除 ${when} 的快照嗎？此操作無法復原`,
    "backupSnapshotDeleted": "已刪除快照",
    "backupSnapshotDeleteFailed": "無法刪除快照",
    "backupSnapshotLimits": (count: number, bytes: number) =>
        `最多 ${count} 份 · ${(bytes / 1024 / 1024).toFixed(0)} MB`,
    "backupSnapshotLimitsCurrent": (count: number, bytes: number, logicalBytes?: number) => {
        const disk = (bytes / 1024 / 1024).toFixed(1)
        const saved = (logicalBytes ?? 0) - bytes
        // 只有去重複效果明顯時才顯示節省量（分塊快照會共用
        // 資料塊）；對很小或未分塊的集合而言，邏輯大小 ≈ 磁碟大小，因此簡單顯示
        // 會比附加「（節省 0 MB）」更清楚。
        if (saved > 1024 * 1024) {
            const data = ((logicalBytes ?? 0) / 1024 / 1024).toFixed(0)
            const savedMB = (saved / 1024 / 1024).toFixed(0)
            return `目前 ${count} 份 · 磁碟占用 ${disk} MB（資料量 ${data} MB，去重複節省 ${savedMB} MB）`
        }
        return `目前 ${count} 份 · 已使用 ${disk} MB`
    },
    "backupSnapshotLimitsChange": "設定上限",
    "backupSnapshotLimitsDialog": "快照保留上限",
    "backupSnapshotLimitsDialogDesc": "系統會以先達到的上限為準。建立新快照時會輪替舊快照；降低上限後會立即刪減，但無論如何都會保留最新一份快照",
    "backupSnapshotLimitsCount": "最大數量",
    "backupSnapshotLimitsBytes": "最大容量（MB）",
    "backupSnapshotLimitsSuccess": (removed: number) =>
        removed > 0 ? `已套用上限（移除 ${removed} 份）` : "已更新上限",
    "backupSnapshotLimitsFailed": "無法更新上限",
    "backupSnapshotLimitsCountRange": (min: number, max: number) =>
        `請輸入 ${min} 到 ${max} 之間的整數`,
    "backupSnapshotLimitsBytesRange": (minMB: number, maxMB: number) =>
        `請輸入 ${minMB} 到 ${maxMB.toLocaleString()} MB 之間的值`,

    "backupServer": "伺服器備份",
    "backupServerDesc": "包含角色資源與內嵌圖片的完整備份，直接儲存在伺服器上；可在下方變更位置",
    "backupServerCreate": "建立備份",
    "backupServerEmpty": "尚未儲存任何備份",
    "backupBootReminder": "啟動時提醒備份",
    "backupBootReminderHint": "從下次啟動開始，在顯示應用程式前詢問是否先建立備份",
    "backupBootReminderToggledOn": "已啟用啟動時備份提醒",
    "backupBootReminderToggledOff": "已停用啟動時備份提醒",
    "backupBootPromptTitle": "現在要建立伺服器備份嗎？",
    "backupBootPromptEstimate": (size: number) =>
        `預估備份大小：${(size / 1024 / 1024).toFixed(0)} MB`,
    "backupBootPromptDisk": (free: number, total: number) =>
        `磁碟可用空間：${(free / 1024 / 1024 / 1024).toFixed(1)} GB／總容量 ${(total / 1024 / 1024 / 1024).toFixed(1)} GB`,
    "backupBootPromptProceed": "立即備份",
    "backupBootPromptSkip": "略過",
    "storageDiskUsageHighWarning": (pct: number) =>
        `磁碟已使用 ${pct.toFixed(0)}% — 建議進行清理`,
    "backupServerInsufficient": "磁碟空間不足，無法建立新備份",
    "updatePopupBackup": "備份",

    "backupServerPath": "儲存位置",
    "backupServerPathDefault": "預設位置",
    "backupServerPathChange": "變更",
    "backupServerPathDialog": "變更備份位置",
    "backupServerPathDialogDesc": "新備份要儲存的資料夾絕對路徑。既有備份檔案會保留在原位置；如有需要，請自行移動",
    "backupServerPathInputLabel": "絕對路徑",
    "backupServerPathSuccess": "已更新備份位置",
    "backupServerPathFailed": "無法更新備份位置",

    "backupLocal": "本機備份",
    "backupLocalDesc": "將備份下載至您的裝置，或從裝置上的備份檔案還原",
    "backupLocalDownload": "將備份下載至裝置",
    "backupLocalDownloadDesc": "使用目前資料建立全新備份，並直接下載至您的裝置",
    "backupLocalRestoreDesc": "從裝置上的備份檔案還原",

    "backupSettingsOnly": "只匯出設定",
    "backupSettingsOnlyDesc": "匯出設定，不包含角色、對話或內嵌圖片。會包含模組、外掛、提示詞預設集、使用者人設、Lorebook、介面主題與 API 金鑰。可用於建立新的 PocketRisu 執行個體",
    "backupSettingsOnlyEstimating": "正在計算大小...",
    "backupSettingsOnlyConfirm": (size: string) =>
        `建立設定備份以移轉至新的執行個體，大小約 ${size}。

• 包含：設定、API 金鑰、模組、外掛、預設集、使用者人設、Lorebook、介面主題
• 不包含：角色、對話記錄、內嵌圖片

還原會覆寫該裝置現有資料。建議還原到全新的執行個體，而非已經有角色的執行個體`,
    "backupSettingsOnlyBreakdown": (
        baseSize: string,
        moduleCount: number,
        assetCount: number,
        moduleSize: string,
    ) =>
        `建立設定備份以移轉至新的執行個體。不包含角色、對話記錄與內嵌圖片。

• 設定、API 金鑰、模組、外掛、預設集、使用者人設、Lorebook、介面主題：${baseSize}
• 模組資源（${moduleCount} 個模組、${assetCount.toLocaleString()} 張圖片）：${moduleSize}

即使不包含資源，模組本身仍會保留；但在新執行個體重新下載這些模組之前，模組圖片會顯示空白`,
    "backupSettingsOnlyWithModuleAssets": (size: string) => `包含模組資源（${size}）`,
    "backupSettingsOnlyWithoutModuleAssets": (size: string) => `僅設定（${size}）`,
    "backupSettingsOnlyModuleAssetsSkipped": "已儲存設定備份。\n\n**未包含模組資源。** 還原後仍會顯示模組及其設定，但模組圖片會是空白。請在新執行個體重新下載這些模組以補回圖片",

    "relatedGithub": "GitHub",
    "relatedGithubDesc": "為此專案加上 Star 以表示支持",
    "support": "贊助",
    "supportBanner": "贊助 PocketRisu",
    "supportTitle": "贊助 PocketRisu",
    "supportThanks": "感謝您的贊助",
    "supportButton": "在 Patreon 上贊助",
    "supportSetName": "公開您的贊助者名稱",
    "supportNotice": "贊助 PocketRisu 完全出於自願；除了在名單中顯示您的名稱外，不會獲得任何額外功能或權益",
    // 僅韓文使用的社群規則通知。此處維持空白，避免其他語系繼承內容並顯示該區塊。
    "supportNoticeWarn": "",
    "supportStatActive": "目前贊助者",
    "supportStatLifetime": "歷來贊助者",
    "supportCaptionActive": "每月持續贊助我們的人",
    "supportCaptionLifetime": "至今曾贊助過我們的所有人",
    "supportPerMonth": "／月",
    "supportEmpty": "成為第一位贊助者",
    "supportLoadFailed": "無法載入贊助者名單",
    "supportRetry": "重試",
    "supportDisabled": "此伺服器已停用更新檢查，因此無法取得贊助者名單",
    "supportUpstream": "贊助原版 Risuai",
    "relatedFeedbackForm": "意見回饋表單",
    "relatedFeedbackFormDesc": "回報問題或提供建議",
    "relatedContactEmail": "聯絡方式",
    "relatedContactEmailDesc": "直接寄送電子郵件給開發者",
    "relatedArcaLive": "ArcaLive 頻道",
    "relatedArcaLiveDesc": "在 AI 聊天頻道與其他使用者交流",

    "selectBotHint": "選擇角色以開始對話",
    "recentChatsTitle": "最近對話",
    "noRecentChatsDesc": "目前沒有對話",
    "hideRecentChats": "隱藏對話清單",
    "hideDeactivatedCharacters": "隱藏已停用角色",
    "hiddenFromSidebarHint": "只會從側邊欄隱藏，不會修改任何資料；與停用角色不同，也不會改善效能",

    "characterManager": "角色管理",
    "characterManagerHint": "停用或移至垃圾桶不再使用的角色，可減少載入與儲存負擔。角色資料仍會保留在伺服器上，之後可隨時重新啟用或還原",
    "characterListSettings": "角色清單設定",
    "sortSidebarOrder": "側邊欄順序",
    "sortRecentChats": "最近對話",
    "sortByName": "名稱",
    "sortByCreated": "加入日期",
    "sortByChatCount": "對話數",
    "hiddenBadge": "已隱藏",
    "hideFromSidebar": "從側邊欄隱藏",
    "showInSidebar": "顯示於側邊欄",
    "selectionCount": (n: number) => `已選取 ${n} 個`,
    "clearSelection": "清除選取",
    "folderSettings": "資料夾設定",
    "folderColor": "資料夾顏色",
    "folderImage": "資料夾圖片",
    "selectImage": "選擇圖片",
    "resetImage": "重設圖片",
    "moveOutOfFolder": "移出資料夾",
    "noFolder": "無資料夾",
    "restore": "還原",
    "deletePermanently": "永久刪除",
    "deactivateSelectedConfirm": (n: number) => `要停用選取的 ${n} 個角色嗎？

停用不再使用的角色可減少載入與儲存負擔，有助於改善效能。資料仍會保留在伺服器上，之後可隨時重新啟用`,
    "trashSelectedConfirm": (n: number) => `要將選取的 ${n} 個角色移至垃圾桶嗎？`,
    "noCharactersFound": "找不到角色",
    "openCharacter": "開啟",
    "activateCharacter": "啟用角色",
    "filterAll": "顯示全部",
    "filterHiddenOnly": "只顯示已隱藏",
    "filterArchivedOnly": "只顯示已停用",
    "folderIcon": "資料夾圖示",
    "folderShowName": "在圖示中顯示資料夾名稱",
    "followGlobalSetting": "跟隨全域設定",
    "showLabel": "顯示",
    "hideLabel": "隱藏",
    "defaultLabel": "預設",
    "emptyTrash": "清空垃圾桶",
    "gridHideNames": "隱藏名稱",
    "moveToTrash": "移至垃圾桶",
    "moveToTrashConfirm": "要移至垃圾桶嗎？角色會被停用並保留在伺服器上，之後可隨時從垃圾桶還原：",
    "trashCharacterDone": "已移至垃圾桶",
    "deleteCharacterFailed": "永久刪除失敗：",
    "folderDisplayMode": "顯示方式",
    "folderModeIcon": "圖示",
    "folderModeImage": "圖片",
    "folderModeName": "名稱",
    "folderImageHint": "選取的圖片會填滿資料夾區塊",
    "emptyTrashConfirm": (n: number) => `要永久刪除垃圾桶中的 ${n} 個角色嗎？此操作無法復原`,
    "moveInsteadOfCopyOnCMPConvert": "CMP 轉換時以移動取代複製",

    "showRequestStatus": "顯示請求狀態",
    "requestStatus": {
        "connecting": "連線中…",
        "thinking": "思考中…",
        "responding": "回應中…",
        "retrying": "重試中…",
        "stalled": "停滯中…",
        "background": "背景執行中…",
        "done": "完成",
        "failed": "失敗",
        "aborted": "已取消",
        "kindMain": "主要模型",
        "kindTranslate": "翻譯",
        "kindMemory": "記憶",
        "kindEmotion": "情緒",
        "kindSub": "輔助模型",
        "outputTokens": "輸出",
        "thinkingTokensLabel": "思考",
        "tokensPerSec": "Token／秒",
        "cacheHit": "快取命中 · {n} Token",
    },

    "deactivateCharacterLostChats": (name: string, count: number, list: string) =>
        `「${name}」的 ${count} 個聊天在伺服器和此瀏覽器中都沒有內容，開啟後顯示為空聊天。\n\n${list}\n\n這些聊天將以空聊天保存。要停用嗎？`,
    "archiveSavePending": "已停用，但尚未儲存到伺服器。將自動重試儲存。",
    "bulkArchiveBusy": "已有多個角色正在處理中。請在完成後再試。",
    "bulkArchiveProgress": (done: number, total: number, trash: boolean) => `${trash ? "正在移至垃圾桶" : "正在停用"}… ${done}/${total}`,
    "bulkArchiveDone": (count: number, trash: boolean) => trash ? `已將 ${count} 個角色移至垃圾桶。` : `已停用 ${count} 個角色。`,
    "bulkArchiveFailed": (done: number, failed: number, list: string) => `已完成 ${done} 個，失敗 ${failed} 個。失敗的角色保持原樣。\n\n${list}`,
    "bulkArchiveStopped": "變更未能儲存到伺服器，其餘角色未處理。已處理的角色會自動重試儲存。",
    "bulkDeactivateLostChats": (count: number, list: string) => `${count} 個角色有在伺服器和此瀏覽器中都沒有內容的聊天，開啟後顯示為空聊天。\n\n${list}\n\n這些聊天將以空聊天保存。也要停用這些角色嗎？`,
    "archiveSaveFailed": "最近的變更未能儲存到伺服器，為保護這些變更已中止。請稍後再試。",
    "activateCharacterAlreadyActive": "伺服器上此角色已是啟用狀態。請重新整理頁面。",
    "settingActionAdd": "新增",
    "settingActionRename": "重新命名",
    "settingActionView": "檢視",
    "settingActionExport": "匯出",
    "settingActionImport": "匯入",
    "settingActionClear": "清除",
    "showStatistics": "使用統計",
    "showStatisticsDesc": "以表格顯示累計的使用統計。",
    "exportSettingsReport": "匯出用於回報問題的設定",
    "exportSettingsReportDesc": "下載移除 API 金鑰、角色等個人資訊後的設定，並複製到剪貼簿。",
    "banCharactersetDesc": "回覆中出現所選文字系統時自動重新生成。",
    "inlayCompressAllDesc": "重新壓縮所有已儲存的內嵌圖片以減少儲存空間。",
    "advTabPrompt": "提示詞·生成",
    "advTabRequest": "請求·模型",
    "advTabAssets": "顯示·資源",
    "advTabDev": "開發·實驗",
    "advSectionResponse": "回覆修正",
    "advSectionDevTools": "開發工具",
    "advSectionExperimental": "實驗功能",
    "risuTosTitle": "RisuAI 服務條款",
    "risuTosDesc": "此功能使用 RisuAI 營運的伺服器。\nPocketRisu 是獨立於 RisuAI 的專案，以下條款是 RisuAI 自己的條款，而非 PocketRisu 的條款。不同意也不影響 PocketRisu 的其他功能。",
    "risuTosScope": "這些條款僅適用於：",
    "risuTosScopeRealm": "RisuRealm（瀏覽、搜尋、下載和檢舉角色）",
    "risuTosScopeMcp": "MCP 伺服器 OAuth 登入（透過 RisuAI 帳號伺服器中繼）",
    "risuTosScopeAccountImport": "從 RisuAI 帳號匯入（登入並下載帳號中儲存的資料）",
    "risuTosTerms": "RisuAI 服務條款",
    "risuTosPrivacy": "RisuAI 隱私權政策",
    "risuTosAccept": "同意",
    "risuTosDecline": "不同意",
    "risuTosGate": "RisuRealm 使用 RisuAI 營運的伺服器。需要同意 RisuAI 服務條款才能使用。",
    "risuTosGateButton": "查看條款",
} satisfies I18nTranslation;

type I18nTranslationFunction = (...args: any[]) => string;

type I18nTranslation = {
    [key: string]: string | I18nTranslation | string[] | I18nTranslationFunction
}
